import React, { Component } from 'react';
import '../homepage.css';
import HomePageHeader from './HomePageHeader';
import { Link } from 'react-router-dom';
import HomePageFooter from './HomePageFooter';
import UserProfile from './UserProfile';
import { Cookies } from 'react-cookie';
import { Tabs, Tab, Modal, Collapse, Well, Button, ProgressBar, Glyphicon } from 'react-bootstrap';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import SimpleReactValidator from 'simple-react-validator';
import 'react-slideshow-image/dist/styles.css';
import Banner1 from '../assets/img/industrialsite.jpg';
import Banner2 from '../assets/img/Ports.jpg';
import Banner3 from '../assets/img/Warehouse.jpg';
import dataLayersPromo from '../assets/img/HPDL_C.png';
import dropdownIcon from '../assets/icons/dropdown.png';
import siteIcon from '../assets/icons/industrialsite.png';
import terminalIcon from '../assets/icons/terminal.png';
import warehouseIcon from '../assets/icons/warehouse.png';
import siteImg from '../assets/img/industrialsite_com.jpg';
import terminalImg from '../assets/img/PTT.jpg';
import warehouseImg from '../assets/img/warehouseimg _c.jpg';
import HeroCarousel from "react-hero-carousel";
import sliderone from '../assets/img/slidehshow_images/indy_s1.jpg';
import slidertwo from '../assets/img/slidehshow_images/Terminal_s2_new.jpg';
import sliderthree from '../assets/img/slidehshow_images/Warehouse_s3.jpg';
import Home from './HomePage/HomePage';
import search from "./HomePage/public/assets/revslider/assets/Search.svg";
import createlist from "./HomePage/public/assets/revslider/assets/CreateListing.svg";
import NavMap1 from "./HomePage/public/assets/images/work/NavMapIcons-07.png";
import NavMap2 from "./HomePage/public/assets/images/work/NavMapIcons-08.png";
import NavMap3 from "./HomePage/public/assets/images/work/NavMapIcons-09.png";
import NavMap4 from "./HomePage/public/assets/images/work/NavMapIcons-10.png";
import ListIconFiltering, {
    getStorageItem
    , getSelectedPropertyTypeAll
} from './ListIconFiltering';
import { LiFilter, createIntermediateArr, createMinMaxValueArr } from './LiFilter';
import {
    LabelValue
    , removeDuplicatesFromArr
    , splitFilter
    , joinFilter
    , joinFilterV
    , TGeoResponse
    , TInFeature
} from '../constant/Types';
import * as MapboxGl from 'mapbox-gl';
import InputMultiSelectComponent from './InputMultiSelectComponent';
import { propertyTypesOptions } from '../constant/PropertyType';
import InputAddressComponent from './InputAddressHome';
import { arrStates } from '../constant/CountryUSA';
import StringUtils from '../utils/StringUtils';
import { getPreciseDistance } from 'geolib';
import { Select } from 'antd';
import 'antd/dist/antd.css';
const { Option } = Select;
const cookies = new Cookies();



const fadeImages = [
    Banner1,
    Banner2,
    Banner3,
];
export const sizeIcoSmall: number = 21;
export const sizeIcoBig: number = 32;
export const placeIcoSmall: number = 43;
export const placeIcoBig: number = 54;
export declare type FitBounds = [[number, number], [number, number]];
export const setStorageItem = (item: string, value: string = ''): void => {
    if (value) {
        localStorage.setItem(item, value);
    } else {
        localStorage.removeItem(item);
    }
}
const initialFitBounds: FitBounds = [[-135, 30.00639444], [-60.237767219999995, 45.935964170000005]];
const isEqualFitBounds = (fitBounds01: FitBounds, fitBounds02: FitBounds) => {
    if (fitBounds01[0][0] !== fitBounds02[0][0]) {
        return false;
    }
    if (fitBounds01[0][1] !== fitBounds02[0][1]) {
        return false;
    }
    if (fitBounds01[1][0] !== fitBounds02[1][0]) {
        return false;
    }
    if (fitBounds01[1][1] !== fitBounds02[1][1]) {
        return false;
    }
    return true;
}
interface PListIconFiltering {
    filterResults: (filter: LiFilter
        , intermediateFeatures: Array<TInFeature>
        , flagPostponedCreate: boolean
        , callback?: () => void) => void;
    handleInitialZoom: () => void;
    updateMapBounds: () => void;
    updateResponse: (flagLoading: boolean, response: { features: Array<TInFeature> }, callback?: () => void) => void;
    sizeIco: number;
    placeIco: number;
    activeHighlightedColor: string;
    privateClientId: string;
}
interface PHomePage {
}
class TIdxCoordinate {
    idx: number = null;
    coordinate: number = null;
}
interface PListing {
    match?: { params: { id: string } };
}

class SHomePage {
    firstname: string = UserProfile.getFirstName() ? UserProfile.getFirstName() : '';
    lastname: string = UserProfile.getLastName() ? UserProfile.getLastName() : '';
    email: string = UserProfile.getEmail() ? UserProfile.getEmail() : '';
    message: string = '';
    showSuccessModal: boolean = false;
    openSearch: boolean = false;
    showfun: boolean = false;
    openPortTerminalsTransloads: boolean = false;
    openWarehouses: boolean = false;
    openSiteBlock1: boolean = false;
    openSiteBlock2: boolean = false;
    openPTTBlock1: boolean = false;
    openPTTBlock2: boolean = false;
    displayImage: string = fadeImages[0];

    // showIndustrialSites: boolean = true;
    showOfferSites: boolean = true;
    showSearchSites: boolean = false;
    // showPTT: boolean = false;
    showPTTOwner: boolean = false;
    showPTTCustomer: boolean = false;
    // showWarehouse: boolean = false;
    showWarehouseSeller: boolean = false;
    showWarehouseBuyer: boolean = false;
    loading: boolean = false;
    openWarehouseBlock1: boolean = false;
    openWarehouseBlock2: boolean = false;



    showNumberColumnsInListing: number = 2;
    innerWidthToHideListingButtons: number = 767;
    innerWidth: number = window.innerWidth;
    innerHeight: number = window.innerHeight;
    listFilteringRef: ListIconFiltering = null;
    fitBounds: FitBounds = initialFitBounds;
    flagLoading: boolean = true;
    flagStyleLoading: boolean = true;
    flyToOptions: number = 0.8;
    flagPerformZoomForPrivateClient: boolean = false;
    flagDisableZoom: boolean = false;
    flagMapMoveUpdateListing: boolean = true;
    flagMeasureDistances: boolean = false;
    mapboxRef: React.Component = null;
    flagToPreventMapResizeCycle: boolean = false;
    match?: { params: { id: string } };
    organizationName: string = '';
    indoorStorage: string = '';
    parkingCapacity: string = '';
    nearestInterstate: string = '';
    milesToInterstate: string = '';
    nearestAirport: string = '';
    milesToAirport: string = '';
    silos: string = '';
    shortLinesDataLayer: string = '';
    classOneConnectionsDataLayer: string = '';
    cityCoordinates: Array<number> = [];
    showCrudeOilPipelines: boolean = false;
    showPetroleumProductPipelines: boolean = false;
    showMajorPorts: boolean = false;
    showRoadways: boolean = false;

    showIndustrialSites: boolean = true;
    showTerminalsAndTransloads: boolean = true;
    showPortTerminals: boolean = true;
    showWarehouses: boolean = true;
    showIntermodalData: boolean = false;
    showClassOneConnOverlay: boolean = false;

    sitesGeoJSONArray: { features: Array<TInFeature> } = { features: [] };
    portTerminalsGeoJSONArray: { features: Array<TInFeature> } = { features: [] };
    otherTerminalsGeoJSONArray: { features: Array<TInFeature> } = { features: [] };
    warehousesGeoJSONArray: { features: Array<TInFeature> } = { features: [] };
    multiPurposeGeoJSONArray: { features: Array<TInFeature> } = { features: [] };
    response: {
        features: Array<TInFeature>
        , latitudeSorted: Array<TIdxCoordinate>
        , longitudeSorted: Array<TIdxCoordinate>
    }
        = {
            features: []
            , latitudeSorted: []
            , longitudeSorted: []
        };
    filter: LiFilter = new LiFilter();
    requiredStateArr: Array<LabelValue> = [];
    sizeIco: number;
    placeIco: number;
    activeHighlightedColor: string;
    privateClientId: string;
    initialFitBoundsTmp: string;
    constructor() {
    }
}

class HomePage extends Component<PHomePage, SHomePage> {
    child: HomePageHeader = null;
    validator: SimpleReactValidator = null;

    constructor(props: PHomePage) {
        super(props);
        // localStorage.setItem('propertyFor', 'Lease or Sale');
        this.state = new SHomePage();
    }

    openSearchBox() {
        this.setState({
            openSearch: !this.state.openSearch
        })
    }

    hanldeBlueSectionScroll = () => {
        document.getElementById('blue-section').scrollIntoView({ behavior: 'smooth' });
    }

    parentHandleShow() {
        // this.child.handleShow(nextURL, type, subType);
        alert('Choose only one property type')
    }

    componentWillMount() {
        this.validator = new SimpleReactValidator({
            element: (message, className) => <div className='text-danger'>{message}</div>
        })
        // fetch(process.env.REACT_APP_BASE_URL + '/api/checkToken', {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Access-Control-Allow-Origin': process.env.REACT_APP_BASE_URL,
        //         'x-access-token': cookies.get('token')
        //     },
        // })
        //     .then(res => {
        //         if (res.status === 200) {
        //             this.setState({ loading: false });
        //         } else {
        //             console.log('in else part ' + res.status)
        //             cookies.remove('token');
        //             UserProfile.forgetEmail();
        //             UserProfile.forgetFirstName();
        //             UserProfile.forgetLastName();
        //             this.forceUpdate();
        //         }
        //     })
        //     .catch(err => {
        //         // this.setState({ loading: false, redirect: true });
        //     });
        this.loadParametersFromLocalStorage();
    }
    loadParametersFromLocalStorage = () => {
        const filter: LiFilter = new LiFilter().copy(this.state.filter);
        // for (let i = 0; i < arrSiteFormKey.length; i++) {
        //  const key: string = arrSiteFormKey[i].key;
        //  const value: string = getStorageItem(key);
        //  filter[key] = value;
        // }
        // for (let i = 0; i < arrTerminalPortFormKey.length; i++) {
        //  const key: string = arrTerminalPortFormKey[i].key;
        //  const value: string = getStorageItem(key);
        //  filter[key] = value;
        // }
        // for (let i = 0; i < arrWarehouseFormKey.length; i++) {
        //  const key: string = arrWarehouseFormKey[i].key;
        //  const value: string = getStorageItem(key);
        //  filter[key] = value;
        // }
        // for (let i = 0; i < arrMarineAccessFormKey.length; i++) {
        //  const key: string = arrMarineAccessFormKey[i].key;
        //  const value: string = getStorageItem(key);
        //  filter[key] = value;
        //  if (key === 'marineAccess' && value) {
        //      filter.bargeAccess = (value.includes('Barge') || value.includes('Vessel')) ? 'Yes' : '';
        //  }
        // }
        // for (let i = 0; i < arrServingCarriersFormKey.length; i++) {
        //  const key: string = arrServingCarriersFormKey[i].key;
        //  const value: string = getStorageItem(key);
        //  filter[key] = value;
        //  if (key === 'marineAccess' && value) {
        //      filter.bargeAccess = (value.includes('Barge') || value.includes('Vessel')) ? 'Yes' : '';
        //  }
        // }
        const classOneMultiservedCheckbox: boolean = getStorageItem('classOneMultiservedCheckbox') === 'true' ? true : false;
        filter.classOneMultiservedCheckbox = (classOneMultiservedCheckbox ? (true === classOneMultiservedCheckbox) : false);
        const selectedPropertyTypeAll = getSelectedPropertyTypeAll();
        filter.selectedPropertyType = getStorageItem('selectedPropertyType', selectedPropertyTypeAll);
        filter.searchByKeywordValue = getStorageItem('searchByKeywordValue');
        filter.selectedUsaStates = getStorageItem('selectedUsaStates');
        filter.address = getStorageItem('address');
        filter.radius = Number(getStorageItem('radius', '0'));
        const cityCoordinates = getStorageItem('cityCoordinates');
        // filter.cityCoordinates = StringUtils.isNotEmpty(cityCoordinates) ? JSON.parse(cityCoordinates) : [];
        filter.city = getStorageItem('city');
        filter.usaState = getStorageItem('usaState');
        filter.zipcode = getStorageItem('zipcode');
        filter.country = getStorageItem('country');
        filter.flagRadiusDisabled = (filter.cityCoordinates && filter.cityCoordinates.length > 1) ? false : true;
        this.setState({
            filter: filter,
        }, () => {
            const { state } = this;
            const { selectedPropertyType } = state.filter;
            const flagIndustrialSitesProperties: boolean = selectedPropertyType.includes('Industrial Sites & Properties');
            const flagPortTerminals: boolean = selectedPropertyType.includes('Port Terminals');
            const flagTerminalsTransload: boolean = selectedPropertyType.includes('Terminals and Transload Facilities');
            const flagWarehouse: boolean = selectedPropertyType.includes('Warehouse/Distribution Center');
            const flagMultipurpose: boolean = selectedPropertyType.includes('Multipurpose');
            if (flagIndustrialSitesProperties) {
                this.setListingFor(selectedPropertyType);
            }
            if (flagWarehouse) {
                this.setListingFor(selectedPropertyType);
                // this.addPTTOptionInListingFor();
            }
            if (flagMultipurpose) {
                this.setListingFor(selectedPropertyType);
                // this.addPTTOptionInListingFor();
            }
            // this.createFiltersIntern(true);
        });
    }

    componentDidMount() {
        //document.getElementById('offerSites').classList.add('active');
    }

    scrollToLearnMore = () => {
        // document.getElementById('learn-more').scrollIntoView({behavior: 'smooth'});

        const element = document.getElementById('learn-more');
        const offset = 45;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - 75 - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
    renderIconFilters = (): React.ReactElement => {
        const { state, props } = this;
        const {
            showNumberColumnsInListing
            , innerWidthToHideListingButtons
            , innerWidth
            // , specificClientConfiguration
        } = state;
        const flagSmallIcons: boolean = innerWidth <= innerWidthToHideListingButtons;
        const sizeIco: number = flagSmallIcons ? sizeIcoSmall : sizeIcoBig;
        const placeIco: number = flagSmallIcons ? placeIcoSmall : placeIcoBig;
        const activeHighlightedColor = null;
        const keySuffix = '_' + sizeIco + '_' + placeIco + '_' + activeHighlightedColor;
        return (
            <ListIconFiltering
                key={'keySuffix_' + keySuffix}
                ref={this.updateListFilteringRef}
                filterResults={
                    (filter: LiFilter, intermediateFeatures: Array<TInFeature>, flagPostponedCreate: boolean) => {
                        this.filterResults(filter, intermediateFeatures, flagPostponedCreate)
                    }}
                handleInitialZoom={() => this.handleInitialZoom()}
                updateMapBounds={() => this.updateMapBounds()}
                updateResponse={
                    (flagLoading: boolean, response: { features: Array<TInFeature> }, callback?: () => void) => {
                        this.updateResponse(flagLoading, response, callback);
                    }}
                sizeIco={sizeIco}
                placeIco={placeIco}
                activeHighlightedColor={activeHighlightedColor}
                privateClientId={this.getPrivateClientId()}
            />
        )
    }
    getPrivateClientId(): string {
        // const { match } = this.props;
        // if (!match || !match.params || !match.params.id) {
        //  return null;
        // }
        return '0';
    }
    updateListFilteringRef = (el: ListIconFiltering) => {
        if (el) {
            this.setState({
                listFilteringRef: el
            });
        }
    }
    updateResponse = (flagLoading: boolean
        , response: { features: Array<TInFeature> } = { features: [] }
        , callback?: () => void
    ) => {
        const responseAdjusted = this.adjustResposeWithIndexData(response);
        this.setState({
            flagLoading: flagLoading
            , response: responseAdjusted
        }, callback);
    }
    adjustResposeWithIndexData = (response: { features: Array<TInFeature> }): {
        features: Array<TInFeature>
        , latitudeSorted: Array<TIdxCoordinate>
        , longitudeSorted: Array<TIdxCoordinate>
    } => {
        const res: {
            features: Array<TInFeature>
            , latitudeSorted: Array<TIdxCoordinate>
            , longitudeSorted: Array<TIdxCoordinate>
        } = {
            ...response
            , latitudeSorted: []
            , longitudeSorted: []
        };
        res.latitudeSorted = this.getLatitudeToIndexArr(response.features);
        res.longitudeSorted = this.getLongitudeToIndexArr(response.features);
        return res;
    }
    handleInitialZoom = () => {
        this.closePopup();
        this.updateMapBounds();
    }
    getLatitudeToIndexArr = (features: Array<TInFeature>): Array<TIdxCoordinate> => {
        const res: Array<TIdxCoordinate> = [];
        for (let i = 0; i < features.length; i++) {
            const inFeature: TInFeature = features[i];
            const lng = inFeature.geometry.coordinates[0];
            const lat = inFeature.geometry.coordinates[1];
            res.push({ idx: i, coordinate: lat });
        }
        return this.sortToIndexArr(res);
    }

    getLongitudeToIndexArr = (features: Array<TInFeature>): Array<TIdxCoordinate> => {
        const res: Array<TIdxCoordinate> = [];
        for (let i = 0; i < features.length; i++) {
            const inFeature: TInFeature = features[i];
            const lng = inFeature.geometry.coordinates[0];
            const lat = inFeature.geometry.coordinates[1];
            res.push({ idx: i, coordinate: lng });
        }
        return this.sortToIndexArr(res);
    }

    sortToIndexArr = (res: Array<TIdxCoordinate>): Array<TIdxCoordinate> => {
        return res.sort(this.compareToIndexArr);
    }

    compareToIndexArr = (a: TIdxCoordinate, b: TIdxCoordinate) => {
        if (a.coordinate < b.coordinate) {
            return -1;
        }
        if (a.coordinate > b.coordinate) {
            return 1;
        }
        return 0;
    }
    updateMapBounds = () => {
        const fitBounds: FitBounds = this.getMapFitBounds();
        this.setFitBounds(fitBounds);
    }
    setFitBounds = (fitBounds: FitBounds, callback?: () => void): boolean => {
        if (isEqualFitBounds(this.state.fitBounds, fitBounds)) {
            return false;
        }
        this.setState({
            fitBounds: fitBounds,
        }, callback);
        return true;
    }
    closePopup = () => {
        // this.setState({
        //  place: undefined,
        // });
    }
    filterResults(filter: LiFilter, intermediateFeatures: Array<TInFeature>, flagPostponedCreate: boolean, callback?: () => void) {
        const { state } = this;
        // const {
        //   specificClientConfiguration
        //  , flagPerformZoomForPrivateClient
        //  , flagDisableZoom
        // } = state;
        const { searchByKeywordValue, selectedPropertyType } = filter;
        let fitBounds: FitBounds = flagPostponedCreate ? state.fitBounds : this.getMapFitBounds();
        let parameter;

        // if (specificClientConfiguration.filteredListing4ShortLines && specificClientConfiguration.filteredListing4ShortLines.length > 0) {
        //  parameter = 'shortLines';
        //  const propertyTypeArr = splitFilter(joinFilterV(specificClientConfiguration.filteredListing4ShortLines));
        //  intermediateFeatures = createIntermediateArr(propertyTypeArr, intermediateFeatures, parameter);
        // }

        if (selectedPropertyType !== '' && selectedPropertyType !== null) {
            parameter = 'propertyType';
            const propertyTypeArr = [selectedPropertyType];
            intermediateFeatures = createIntermediateArr(propertyTypeArr, intermediateFeatures, parameter, selectedPropertyType, '');
        } else {
            intermediateFeatures.length = 0;
        }

        if (state.organizationName) {
            parameter = 'organizationName';
            const organizationNameArr = [state.organizationName];
            intermediateFeatures = createIntermediateArr(organizationNameArr, intermediateFeatures, parameter, '', '');
        }

        const flagIndustrialSitesProperties: boolean = selectedPropertyType.includes('Industrial Sites & Properties');
        const flagPortTerminals: boolean = selectedPropertyType.includes('Port Terminals');
        const flagTerminalsTransload: boolean = selectedPropertyType.includes('Terminals and Transload Facilities');
        const flagWarehouse: boolean = selectedPropertyType.includes('Warehouse/Distribution Center');
        const flagMultipurpose: boolean = selectedPropertyType.includes('Multipurpose');
        if (flagIndustrialSitesProperties || flagMultipurpose) {
            if (filter.selectedPropertyFor !== '' && filter.selectedPropertyFor !== null) {
                if (filter.selectedPropertyFor !== 'Lease and/or Sale') {
                    parameter = 'propertyFor';
                    const propertyForArr = [filter.selectedPropertyFor];
                    intermediateFeatures = createIntermediateArr(propertyForArr, intermediateFeatures, parameter, selectedPropertyType, '');
                }
            }

            if (filter.minAcreage !== '') {
                parameter = 'acreage';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.minAcreage, intermediateFeatures, 'min');
            }

            if (filter.maxAcreage !== '') {
                parameter = 'acreage';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.maxAcreage, intermediateFeatures, 'max');
            }

            if (filter.minPrice !== '') {
                parameter = 'price';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.minPrice, intermediateFeatures, 'min');
            }

            if (filter.maxPrice !== '') {
                parameter = 'price';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.maxPrice, intermediateFeatures, 'max');
            }

            if (filter.siteZoning !== '') {
                parameter = 'zoning';
                const siteZoningArr = [filter.siteZoning];
                intermediateFeatures = createIntermediateArr(siteZoningArr, intermediateFeatures, parameter, 'Sites', '');
            }

            if (filter.selectedBuildingOption !== '' && filter.selectedBuildingOption !== null) {
                parameter = 'building';
                const selectedBuildingOptionArr = [filter.selectedBuildingOption];
                intermediateFeatures = createIntermediateArr(selectedBuildingOptionArr, intermediateFeatures, parameter, 'Sites', '');
            }

            if (filter.siteMinSquareFeet !== '') {
                parameter = 'squareFeet';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.siteMinSquareFeet, intermediateFeatures, 'min');
            }

            if (filter.siteMaxSquareFeet !== '') {
                parameter = 'squareFeet';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.siteMaxSquareFeet, intermediateFeatures, 'max');
            }

            if (filter.siteMinInteriorRoofHeight !== '') {
                parameter = 'interiorRoofHeight';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.siteMinInteriorRoofHeight, intermediateFeatures, 'min');
            }

            if (filter.siteSuitableFor !== '' && filter.siteSuitableFor !== null) {
                parameter = 'suitableFor';
                const siteSuitableForArr = [filter.siteSuitableFor];
                intermediateFeatures = createIntermediateArr(siteSuitableForArr, intermediateFeatures, parameter, 'Sites', '');
            }

            if (filter.sitePipelineAccess != '' && filter.sitePipelineAccess !== null) {
                parameter = 'pipelineAccess';
                const sitePipelineAccessArr = [filter.sitePipelineAccess];
                intermediateFeatures = createIntermediateArr(sitePipelineAccessArr, intermediateFeatures, parameter, 'Sites', '');
            }

            // if (state.selectedWaterSewer !== '' && state.selectedWaterSewer !== null) {
            //  parameter = 'waterSewerInPlace';
            //  const selectedWaterSewerArr = [state.selectedWaterSewer];
            //  intermediateFeatures = createIntermediateArr(selectedWaterSewerArr, intermediateFeatures, parameter, 'Sites', '');
            // }

            if (filter.selectedPowerToSite !== '' && filter.selectedPowerToSite !== null) {
                parameter = 'electricPowerInPlace';
                const selectedPowerToSiteArr = [filter.selectedPowerToSite];
                intermediateFeatures = createIntermediateArr(selectedPowerToSiteArr, intermediateFeatures, parameter, 'Sites', '');
            }

            if (filter.minServiceVoltage !== '') {
                parameter = 'serviceVoltage';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.minServiceVoltage, intermediateFeatures, 'min');
            }

            if (filter.maxServiceVoltage !== '') {
                parameter = 'serviceVoltage';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.maxServiceVoltage, intermediateFeatures, 'max');
            }

            if (filter.minDistanceToSubstation !== '') {
                parameter = 'distanceToSubstation';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.minDistanceToSubstation, intermediateFeatures, 'min');
            }

            if (filter.maxDistanceToSubstation !== '') {
                parameter = 'distanceToSubstation';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.maxDistanceToSubstation, intermediateFeatures, 'max');
            }

            if (filter.naturalGasInPlace !== '' && filter.naturalGasInPlace !== null) {
                parameter = 'naturalGasInPlace';
                const naturalGasInPlaceArr = [filter.naturalGasInPlace];
                intermediateFeatures = createIntermediateArr(naturalGasInPlaceArr, intermediateFeatures, parameter, 'Sites', '');
            }

            if (filter.minLineDiameter !== '') {
                parameter = 'lineDiameter';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.minLineDiameter, intermediateFeatures, 'min');
            }

            if (filter.maxLineDiameter !== '') {
                parameter = 'lineDiameter';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.maxLineDiameter, intermediateFeatures, 'max');
            }

            if (filter.siteEnvionmental !== '' && filter.siteEnvionmental !== null) {
                parameter = 'environmental';
                const siteEnvionmentalArr = [filter.siteEnvionmental];
                intermediateFeatures = createIntermediateArr(siteEnvionmentalArr, intermediateFeatures, parameter, 'Sites', '');
            }

            if (filter.airAttainmentStatus !== '' && filter.airAttainmentStatus !== null) {
                parameter = 'airAttainmentStatus';
                const airAttainmentStatusArr = [filter.airAttainmentStatus];
                intermediateFeatures = createIntermediateArr(airAttainmentStatusArr, intermediateFeatures, parameter, 'Sites', '');
            }
        }

        // // Ports, Terminals and Transloads Search & Filters
        if (flagPortTerminals || flagTerminalsTransload || flagMultipurpose) {
            if (filter.capabilities !== '' && filter.capabilities !== null) {
                parameter = 'capabilities';
                const capabilitiesArr = [filter.capabilities];
                intermediateFeatures = createIntermediateArr(capabilitiesArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.equipments !== '' && filter.equipments !== null) {
                parameter = 'equipments';
                const equipmentsArr = [filter.equipments];
                intermediateFeatures = createIntermediateArr(equipmentsArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.railcarStorageCapacity !== '') {
                parameter = 'railcarStorageCapacity';
                const railcarStorageCapacityArr = [filter.railcarStorageCapacity];
                intermediateFeatures = createIntermediateArr(railcarStorageCapacityArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.productsHandled !== '' && filter.productsHandled !== null) {
                parameter = 'productsHandled';
                const productsHandledArr = [filter.productsHandled];
                intermediateFeatures = createIntermediateArr(productsHandledArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.productStorage !== '' && filter.productStorage !== null) {
                parameter = 'productStorage';
                const productStorageArr = [filter.productStorage];
                intermediateFeatures = createIntermediateArr(productStorageArr, intermediateFeatures, parameter, '', '');
            }

            if (state.indoorStorage !== '' && state.indoorStorage !== null) {
                parameter = 'indoorStorage';
                const indoorStorageArr = [state.indoorStorage];
                intermediateFeatures = createIntermediateArr(indoorStorageArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.pttMinAcreage) {
                parameter = 'pttAcreage';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.pttMinAcreage, intermediateFeatures, 'min');
            }

            if (filter.pttMaxAcreage) {
                parameter = 'pttAcreage';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.pttMaxAcreage, intermediateFeatures, 'max');
            }
        }

        // Warehouse Criteria Search & Filters
        if (flagWarehouse || flagMultipurpose) {
            if (filter.selectedPropertyFor1 !== '' && filter.selectedPropertyFor1 !== null) {
                if (filter.selectedPropertyFor1 !== 'Lease and/or Sale') {
                    parameter = 'propertyFor';
                    const propertyForArr = [filter.selectedPropertyFor1];
                    intermediateFeatures = createIntermediateArr(propertyForArr, intermediateFeatures, parameter, selectedPropertyType, '');
                }
            }

            if (filter.warehouseMinPrice) {
                parameter = 'warehousePrice';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.warehouseMinPrice, intermediateFeatures, 'min');
            }

            if (filter.warehouseMaxPrice) {
                parameter = 'warehousePrice';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.warehouseMaxPrice, intermediateFeatures, 'max');
            }

            if (filter.warehouseCapabilities) {
                parameter = 'warehouseCapabilities';
                const warehouseCapabilitiesArr = [filter.warehouseCapabilities];
                intermediateFeatures = createIntermediateArr(warehouseCapabilitiesArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.warehouseMinSize !== '') {
                parameter = 'warehouseMinSize';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.warehouseMinSize, intermediateFeatures, 'min');
            }

            if (filter.warehouseMaxSize !== '') {
                parameter = 'warehouseMaxSize';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.warehouseMaxSize, intermediateFeatures, 'max');
            }

            if (filter.temperatureControl !== '' && filter.temperatureControl !== null) {
                parameter = 'temperatureControl';
                const temperatureControlArr = [filter.temperatureControl];
                intermediateFeatures = createIntermediateArr(temperatureControlArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.parkingSpaces !== '') {
                parameter = 'parkingSpaces';
                const parkingSpacesArr = [filter.parkingSpaces];
                intermediateFeatures = createIntermediateArr(parkingSpacesArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.foodGrade !== '' && filter.foodGrade !== null) {
                parameter = 'foodGrade';
                const foodGradeArr = [filter.foodGrade];
                intermediateFeatures = createIntermediateArr(foodGradeArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.freeTradeZone !== '' && filter.freeTradeZone !== null) {
                parameter = 'freeTradeZone';
                const freeTradeZoneArr = [filter.freeTradeZone];
                intermediateFeatures = createIntermediateArr(freeTradeZoneArr, intermediateFeatures, parameter, '', '');
            }

            if (filter.minRoofHeight) {
                parameter = 'roofHeight';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.minRoofHeight, intermediateFeatures, 'min');
            }

            if (filter.maxRoofHeight) {
                parameter = 'roofHeight';
                intermediateFeatures = createMinMaxValueArr(parameter, filter.maxRoofHeight, intermediateFeatures, 'max');
            }
        }

        // // Marine Access Search & Filters
        if (filter.marineAccess !== '' && filter.marineAccess !== null) {
            parameter = 'marineAccess';
            const marineAccessArr = [filter.marineAccess];
            intermediateFeatures = createIntermediateArr(marineAccessArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.bargeAccess !== '' && filter.bargeAccess !== null) {
            parameter = 'bargeAccess';
            const selectedSiteBargeAccessArr = [filter.bargeAccess];
            intermediateFeatures = createIntermediateArr(selectedSiteBargeAccessArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.docInPlace !== '' && filter.docInPlace !== null) {
            parameter = 'docInPlace';
            const docInPlaceArr = [filter.docInPlace];
            intermediateFeatures = createIntermediateArr(docInPlaceArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.navigableWater !== '') {
            parameter = 'distancetoWater';
            const navigableWaterArr = [filter.navigableWater];
            intermediateFeatures = createIntermediateArr(navigableWaterArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.waterways !== '' && filter.waterways !== null) {
            parameter = 'waterways';
            const waterwaysArr = [filter.waterways];
            intermediateFeatures = createIntermediateArr(waterwaysArr, intermediateFeatures, parameter, '', '');
        }

        // Serving Rail Carriers Search & Filters

        // this.setState({
        //  shortLines:localStorage.getItem('shortLinesLabel') ? localStorage.getItem('shortLinesLabel'):''
        // })
        if (filter.shortLinesLabel !== '' && filter.shortLinesLabel !== null) {
            parameter = 'shortLines';
            const shortLinesArr = [filter.shortLinesLabel];
            intermediateFeatures = createIntermediateArr(shortLinesArr, intermediateFeatures, parameter, '', '');
        }

        // code to create array if multi-served class I conn and/or Class I conn selected
        const tempIntermediateFeatures = intermediateFeatures;
        const classOneMultiservedArr = [];
        if (filter.classOneMultiservedCheckbox && filter.classOneConnections) {
            // create array of records which contains multiple class I conn
            for (let k = 0; k < tempIntermediateFeatures.length; k++) {
                if (tempIntermediateFeatures[k].properties.classOneConnections.includes('*')) {
                    classOneMultiservedArr.push(tempIntermediateFeatures[k]);
                }
            }

            parameter = 'classOneConnections';
            const siteClassOneConnectionsArr = [filter.classOneConnections];
            intermediateFeatures = createIntermediateArr(siteClassOneConnectionsArr, intermediateFeatures, parameter, '', '');

            // concat above 2 arrays
            Array.prototype.push.apply(intermediateFeatures, classOneMultiservedArr);

        } else if (filter.classOneMultiservedCheckbox) {
            // create array of records which contains multiple class I conn
            for (let k = 0; k < tempIntermediateFeatures.length; k++) {
                if (tempIntermediateFeatures[k].properties.classOneConnections.includes('*')) {
                    classOneMultiservedArr.push(tempIntermediateFeatures[k]);
                }
            }
            intermediateFeatures = classOneMultiservedArr;

        } else if (filter.classOneConnections) {
            parameter = 'classOneConnections';
            const siteClassOneConnectionsArr = [filter.classOneConnections];
            intermediateFeatures = createIntermediateArr(siteClassOneConnectionsArr, intermediateFeatures, parameter, '', '');
        } else {
            console.log('Both class one conn and multi-served checkbox are not selected')
        }

        if (filter.railInPlace !== '' && filter.railInPlace !== null) {
            parameter = 'railInPlace';
            const selectedRailInPlaceArr = [filter.railInPlace];
            intermediateFeatures = createIntermediateArr(selectedRailInPlaceArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.railcarStorage !== '' && filter.railcarStorage !== null) {
            parameter = 'railcarStorage';
            const railcarStorageArr = [filter.railcarStorage];
            intermediateFeatures = createIntermediateArr(railcarStorageArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.unitTrainCapable) {
            parameter = 'unitTrainCapable';
            const unitTrainCapableArr = [filter.unitTrainCapable];
            intermediateFeatures = createIntermediateArr(unitTrainCapableArr, intermediateFeatures, parameter, '', '');
        }

        if (filter.railcarCapacity) {
            parameter = 'railcarCapacity';
            intermediateFeatures = createMinMaxValueArr(parameter, filter.railcarCapacity, intermediateFeatures, 'min');
        }

        // Additional Attributes Search and Filters
        if (state.parkingCapacity !== '' && state.parkingCapacity !== null) {
            parameter = 'parkingCapacity';
            const parkingCapacityArr = [state.parkingCapacity];
            intermediateFeatures = createIntermediateArr(parkingCapacityArr, intermediateFeatures, parameter, '', '');
        }

        if (state.nearestInterstate !== '') {
            parameter = 'nearestInterstate';
            const nearestInterstateArr = [state.nearestInterstate];
            intermediateFeatures = createIntermediateArr(nearestInterstateArr, intermediateFeatures, parameter, '', '');
        }

        if (state.milesToInterstate !== '') {
            parameter = 'milesToInterstate';
            const milesToInterstateArr = [state.milesToInterstate];
            intermediateFeatures = createIntermediateArr(milesToInterstateArr, intermediateFeatures, parameter, '', '');
        }

        if (state.nearestAirport !== '') {
            parameter = 'nearestAirport';
            const nearestAirportArr = [state.nearestAirport];
            intermediateFeatures = createIntermediateArr(nearestAirportArr, intermediateFeatures, parameter, '', '');
        }

        if (state.milesToAirport !== '') {
            parameter = 'milesToAirport';
            const milesToAirportArr = [state.milesToAirport];
            intermediateFeatures = createIntermediateArr(milesToAirportArr, intermediateFeatures, parameter, '', '');
        }

        if (state.silos !== '' && state.silos !== null) {
            parameter = 'silos';
            const silosArr = [state.silos];
            intermediateFeatures = createIntermediateArr(silosArr, intermediateFeatures, parameter, '', '');
        }

        intermediateFeatures = removeDuplicatesFromArr(intermediateFeatures);

        const originalResponse = getStorageItem('originalResponse');
        const geoResponse: { features: Array<TInFeature> } = originalResponse && originalResponse.length > 0 ? JSON.parse(originalResponse) : [];

        const sitesGeoJSONArray: { features: Array<TInFeature> } = { features: null };
        const warehousesGeoJSONArray: { features: Array<TInFeature> } = { features: null };
        const portTerminalsGeoJSONArray: { features: Array<TInFeature> } = { features: null };
        const otherTerminalsGeoJSONArray: { features: Array<TInFeature> } = { features: null };
        const multiPurposeGeoJSONArray: { features: Array<TInFeature> } = { features: null };

        // Filter real estates that contain the values from the search field in properties
        const minSymbolsToSearch = 2
        if (searchByKeywordValue && searchByKeywordValue.length >= minSymbolsToSearch) {
            intermediateFeatures = this.filterEstatesByKeywords(intermediateFeatures, filter.searchByKeywordValue);
        }

        const realEstates = this.filterEstatesByTypes(intermediateFeatures);

        geoResponse.features = intermediateFeatures;
        sitesGeoJSONArray.features = realEstates.industrialSites;
        portTerminalsGeoJSONArray.features = realEstates.portTerminals;
        otherTerminalsGeoJSONArray.features = realEstates.terminalsAndFacilities;
        warehousesGeoJSONArray.features = realEstates.warehouseAndDistributionCenter;
        multiPurposeGeoJSONArray.features = realEstates.multiPurpose;
        // if (flagPerformZoomForPrivateClient) {
        //  let deltaPlus: number = 4.0;
        //  if (specificClientConfiguration.outlineInDegrees) {
        //      deltaPlus = specificClientConfiguration.outlineInDegrees;
        //  }
        //  fitBounds = this.calculateBounds4Features(intermediateFeatures, deltaPlus, fitBounds);
        // } else if (!flagPostponedCreate && !flagDisableZoom) {
        //  fitBounds = this.calculateBounds4Features(intermediateFeatures, 2.2, fitBounds);
        // }
        fitBounds = this.calculateBounds4Features(intermediateFeatures, 2.2, fitBounds);
        const flagMajorports: boolean = getStorageItem('showMajorPorts') != 'true' ? false : true;
        const flagshowIntermodalData: boolean = getStorageItem('showIntermodalData') != 'true' ? false : true;
        const flagshowCrudeOilPipelines: boolean = getStorageItem('showCrudeOilPipelines') != 'true' ? false : true;
        const flagshowPetroleumProductPipelines: boolean = getStorageItem('showPetroleumProductPipelines') != 'true' ? false : true;
        const flagshowRoadways: boolean = getStorageItem('showRoadways') != 'true' ? false : true;
        const flagclassOneConnectionsDataLayer: string = getStorageItem('classOneConnectionsDataLayer') ? getStorageItem('classOneConnectionsDataLayer') : '';
        const flagshortLinesDataLayer: string = getStorageItem('shortLinesDataLayer') ? getStorageItem('shortLinesDataLayer') : '';
        const showIndustrialSites = flagIndustrialSitesProperties;
        const showTerminalsAndTransloads = flagTerminalsTransload;
        const showPortTerminals = flagPortTerminals;
        const showWarehouses = flagWarehouse;
        const responseAdjusted = this.adjustResposeWithIndexData(geoResponse);
        this.setState({
            response: responseAdjusted
            , sitesGeoJSONArray: sitesGeoJSONArray
            , warehousesGeoJSONArray: warehousesGeoJSONArray
            , portTerminalsGeoJSONArray: portTerminalsGeoJSONArray
            , otherTerminalsGeoJSONArray: otherTerminalsGeoJSONArray
            , multiPurposeGeoJSONArray: multiPurposeGeoJSONArray
            , cityCoordinates: filter.cityCoordinates
            , fitBounds: fitBounds
            , flagPerformZoomForPrivateClient: false
            , flagDisableZoom: false
            , classOneConnectionsDataLayer: flagclassOneConnectionsDataLayer
            , shortLinesDataLayer: flagshortLinesDataLayer
            , showMajorPorts: flagMajorports
            , showRoadways: flagshowRoadways
            , showIntermodalData: flagshowIntermodalData
            , showCrudeOilPipelines: flagshowCrudeOilPipelines
            , showPetroleumProductPipelines: flagshowPetroleumProductPipelines
            , showIndustrialSites: showIndustrialSites
            , showTerminalsAndTransloads: showTerminalsAndTransloads
            , showPortTerminals: showPortTerminals
            , showWarehouses: showWarehouses
        }, callback);
    }
    getMapFitBounds = (flagPerformResize: boolean = true): FitBounds => {
        return this.getMapBounds(true, flagPerformResize);
    }
    flagToPreventMapResizeCycle: boolean = false;
    getMapBounds = (flagCheckLoaded: boolean, flagPerformResize: boolean = true): FitBounds => {
        let fitBounds: FitBounds = this.state.fitBounds;
        const map = this.getMapRef();
        if (flagCheckLoaded && map) {
            flagCheckLoaded = map.loaded();
        } else {
            flagCheckLoaded = true;
        }
        if (map && flagCheckLoaded && !this.state.flagLoading) {
            if (flagPerformResize) {
                this.flagToPreventMapResizeCycle = true;
                map.resize();
                this.flagToPreventMapResizeCycle = false;
            }
            const lngLatBounds = map.getBounds();
            const southWest: [number, number] = [lngLatBounds.getWest(), lngLatBounds.getSouth()];
            const northEast: [number, number] = [lngLatBounds.getEast(), lngLatBounds.getNorth()];
            fitBounds = [southWest, northEast];
        }
        return fitBounds;
    }
    getMapRef = (): MapboxGl.Map => {
        const { state } = this;
        if (!state) {
            return null;
        }
        const { mapboxRef } = state;
        if (!mapboxRef) {
            return null;
        }
        const stateMapbox: any = mapboxRef.state;
        if (!stateMapbox) {
            return null;
        }
        const map: MapboxGl.Map = stateMapbox.map;
        if (!map) {
            return null;
        }
        return map;
    }
    calculateBounds4Features = (intermediateFeatures: Array<TInFeature>, deltaPlus: number = 0.0, boudsDefault: FitBounds = null): FitBounds => {
        let res: FitBounds = boudsDefault;
        if (intermediateFeatures.length <= 0) {
            return res;
        }
        let lngMin = 1000000000, lngMax = -1000000000;
        let latMin = 1000000000, latMax = -1000000000;
        for (let i = 0; i < intermediateFeatures.length; i++) {
            const lng = intermediateFeatures[i].geometry.coordinates[0];
            const lat = intermediateFeatures[i].geometry.coordinates[1];
            if (lngMin > lng) {
                lngMin = lng;
            }
            if (lngMax < lng) {
                lngMax = lng;
            }
            if (latMin > lat) {
                latMin = lat;
            }
            if (latMax < lat) {
                latMax = lat;
            }
        }
        lngMin -= deltaPlus;
        latMin -= deltaPlus;
        lngMax += deltaPlus;
        latMax += deltaPlus;
        res = [[lngMin, latMin], [lngMax, latMax]];
        return res;
    }
    filterEstatesByKeywords = (data: Array<TInFeature>, searchByKeywordValue: string): Array<TInFeature> => {
        const keywords = searchByKeywordValue.toLowerCase().split(',');
        const minSymbolsToSearch = 2;
        const multipleKeywordsDelimeter = '+';
        return data.filter(({ properties: { ...restProps } = {} }) => {
            // convert real estates attributes values into a single string
            const props = Object.values(restProps)
                .filter((value) => value && typeof value !== 'object')
                .join(',')
                .toLowerCase();
            return keywords.some((keyword) => {
                // find real estate which includes all keywords
                if (keyword.includes(multipleKeywordsDelimeter)) {
                    const multipleKeywords = keyword
                        .split('+')
                        .filter((keyword) => keyword && keyword.length >= minSymbolsToSearch);
                    if (!multipleKeywords.length) return true;
                    return multipleKeywords.every((keyword) => props.includes(keyword));
                }
                return props.includes(keyword);
            });
        });
    }

    filterEstatesByTypes = (data: Array<TInFeature>): any => {
        const types = {
            industrialSites: 'Industrial Sites & Properties',
            portTerminals: 'Port Terminals',
            terminalsAndFacilities: 'Terminals and Transload Facilities',
            warehouseAndDistributionCenter: 'Warehouse/Distribution Center',
            multiPurpose: 'Multipurpose',
        }
        const result = Object.keys(types).reduce((obj, key) => {
            const groupedByType: Array<TInFeature> = data.filter(({ properties: { propertyType = '' } = {} }) => {
                const propertyTypeArr: Array<string> = [
                    'Industrial Sites & Properties*Port Terminals*Warehouse/Distribution Center',
                    'Industrial Sites & Properties*Terminals and Transload Facilities*Warehouse/Distribution Center',
                    'Industrial Sites & Properties*Port Terminals',
                    'Industrial Sites & Properties*Terminals and Transload Facilities',
                    'Port Terminals*Warehouse/Distribution Center',
                    'Terminals and Transload Facilities*Warehouse/Distribution Center',
                    'Industrial Sites & Properties*Warehouse/Distribution Center',
                ];
                if (types[key] === 'Multipurpose') {
                    if (propertyTypeArr.includes(propertyType)) {
                        return true;
                    }
                }
                if (propertyType) {
                    return propertyType === types[key];
                }
                return false;
            });
            obj[key] = groupedByType;
            return obj;
        }, {});
        return result;
    }
    setFirstName = (event) => {
        this.setState({ firstname: event.target.value });
    }

    setLastName = (event) => {
        this.setState({ lastname: event.target.value });
    }

    setEmail = (event) => {
        this.setState({ email: event.target.value });
    }

    setMessage = (event) => {
        this.setState({ message: event.target.value });
    }

    handleContactUs = () => {
        if (this.validator.allValid()) {
            axios.post(process.env.REACT_APP_BASE_URL + '/api/contact-us',
                {
                    headers: {
                        'Content-Type': 'application/json',
                        // 'x-access-token': cookies.get('token')
                    },
                    // withCredentials: true,
                    place_owner_name: '',
                    place_id: '',
                    name: this.state.firstname + ' ' + this.state.lastname,
                    email: this.state.email,
                    message: this.state.message,
                }).then(response => {
                    if (response.status === 200) {
                        this.setState({
                            message: '',
                            showSuccessModal: true,
                        });
                    } else {

                    }
                }).catch(function (error) {
                    console.log(error)
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleSuccessModal = () => {
        this.setState({ showSuccessModal: false });
    }

    closeInfoBox = () => {
        this.setState({
            openSiteBlock1: false,
            openSiteBlock2: false,
            openPTTBlock1: false,
            openPTTBlock2: false,
            openWarehouseBlock1: false,
            openWarehouseBlock2: false
        });
    }
    handleSelectPropertyType = (name: string, valueArr: Array<LabelValue>) => {
        console.log("valueArr", valueArr)
        const selectedPropertyType = joinFilterV(valueArr);
        const flagIndustrialSitesProperties: boolean = selectedPropertyType.includes('Industrial Sites & Properties');
        const flagPortTerminals: boolean = selectedPropertyType.includes('Port Terminals');
        const flagTerminalsTransload: boolean = selectedPropertyType.includes('Terminals and Transload Facilities');
        const flagWarehouse: boolean = selectedPropertyType.includes('Warehouse/Distribution Center');
        const flagMultipurpose: boolean = selectedPropertyType.includes('Multipurpose');
        if (flagIndustrialSitesProperties) {
            this.setListingFor(selectedPropertyType);
        }
        if (flagWarehouse) {
            // this.addColdStorageInCapabilities();
            this.setListingFor(selectedPropertyType);
        }
        if (flagMultipurpose) {
            this.setListingFor(selectedPropertyType);
            // this.addColdStorageInCapabilities();
        }
        if (!flagWarehouse && !flagMultipurpose) {
            // this.removePTTOptionFromListingFor();
        }
        const filter: LiFilter = new LiFilter().copy(this.state.filter);
        filter.selectedPropertyType = selectedPropertyType;
        this.setState({
            filter: filter
        }, () => {
            // this.createFilters();
            setStorageItem(name, selectedPropertyType);
        });
    }
    setListingFor = (value: string) => {
        if (value.includes('Warehouse') || value.includes('Multipurpose')) {
            // this.addPTTOptionInListingFor();
        }
    }
    resetAddress = (callback?: () => void) => {
        const filter: LiFilter = new LiFilter().copy(this.state.filter);
        filter.resetAddress();
        this.setState({
            filter: filter,
        }, () => {
            setStorageItem('selectedUsaStates');
            setStorageItem('city');
            setStorageItem('usaState');
            setStorageItem('zipcode');
            setStorageItem('country');
            setStorageItem('address');
            if (callback) {
                callback();
            }
        });
    }
    clearAddress = () => {
        this.handleAddressChange('', [], '', '', '', '');
    }
    handleAddressChange = (
        address: string
        , coordinates: Array<number>
        , city: string
        , usaState: string
        , zipCode: string
        , country: string
    ) => {
        const flagCoordinates: boolean = coordinates !== null && coordinates.length > 1;
        const { state } = this;
        // const filter: LiFilter = new LiFilter().copy(state.filter);
        const filter: LiFilter = new LiFilter();
        localStorage.setItem('showMajorPorts', 'false')
        localStorage.removeItem('classOneConnectionsDataLayer')
        localStorage.removeItem('shortLinesDataLayer')
        localStorage.setItem('showIntermodalData', 'false')
        localStorage.setItem('showCrudeOilPipelines', 'false')
        localStorage.setItem('showPetroleumProductPipelines', 'false')
        localStorage.setItem('showRoadways', 'false')
        this.setState({
            filter: filter,
        }, () => {
            Object.keys(filter).forEach(key => setStorageItem(key));
            const selectedPropertyTypeAll = getSelectedPropertyTypeAll();
            setStorageItem('selectedPropertyType', selectedPropertyTypeAll);
            filter.selectedPropertyType = getStorageItem('selectedPropertyType', selectedPropertyTypeAll);

        })
        filter.selectedUsaStates = '';
        filter.radius = 200;
        filter.address = address ? address : '';
        filter.city = city ? city : '';
        filter.usaState = usaState ? usaState : '';
        filter.zipcode = zipCode ? zipCode : '';
        filter.country = country ? country : '';
        filter.flagRadiusDisabled = flagCoordinates ? false : true;
        filter.cityCoordinates = flagCoordinates ? coordinates : [];
        this.setState({
            filter: filter,
        }, () => {
            setStorageItem('selectedUsaStates');
            setStorageItem('radius', '' + filter.radius);
            setStorageItem('address', filter.address);
            setStorageItem('cityCoordinates', JSON.stringify(filter.cityCoordinates));
            setStorageItem('city', filter.city);
            setStorageItem('usaState', filter.usaState);
            setStorageItem('zipcode', filter.zipcode);
            setStorageItem('country', filter.country);
            if (flagCoordinates) {
                const deltaPlus = 4.0;
                let lngMin = coordinates[0], lngMax = coordinates[0];
                let latMin = coordinates[1], latMax = coordinates[1];
                lngMin -= deltaPlus;
                latMin -= deltaPlus;
                lngMax += deltaPlus;
                latMax += deltaPlus;
                const initialFitBoundsTmp = [[lngMin, latMin], [lngMax, latMax]];
                this.setState({
                    initialFitBoundsTmp: JSON.stringify(initialFitBoundsTmp)
                })
                setStorageItem('initialFitBounds', JSON.stringify(initialFitBoundsTmp));
            } else {
                setStorageItem('initialFitBounds', '');
            }
            // this.createFilters();
        });
    }

    addlistType = (selectedPropertyType: string) => {
        // const selectedPropertyType = joinFilterV(valueArr);
        // const flagIndustrialSitesProperties: boolean = selectedPropertyType.includes('Industrial Sites & Properties');
        // const flagPortTerminals: boolean = selectedPropertyType.includes('Port Terminals');
        // const flagTerminalsTransload: boolean = selectedPropertyType.includes('Terminals and Transload Facilities');
        // const flagWarehouse: boolean = selectedPropertyType.includes('Warehouse/Distribution Center');
        // const flagMultipurpose: boolean = selectedPropertyType.includes('Multipurpose');
        // if (flagIndustrialSitesProperties) {
        //     this.setListingFor(selectedPropertyType);
        // }
        // if (flagWarehouse) {
        //     // this.addColdStorageInCapabilities();
        //     this.setListingFor(selectedPropertyType);
        // }
        // if (flagMultipurpose) {
        //     this.setListingFor(selectedPropertyType);
        //     // this.addColdStorageInCapabilities();
        // }
        // if (!flagWarehouse && !flagMultipurpose) {
        //     // this.removePTTOptionFromListingFor();
        // }
        setStorageItem('selectedPropertyType', selectedPropertyType);
        // const filter: LiFilter = new LiFilter().copy(this.state.filter);
        // filter.selectedPropertyType = selectedPropertyType;
        // this.setState({
        //     filter: filter
        // }, () => {
        //     // this.createFilters();
        //     setStorageItem('selectedPropertyType', selectedPropertyType);
        // });
    }
    handleChange = (value) => {
        // console.log(`selected ${value}`);
        var finaldata = value.join(" * ");
        const selectedPropertyType = value.sort().join('*');
        const flagIndustrialSitesProperties: boolean = selectedPropertyType.includes('Industrial Sites & Properties');
        const flagPortTerminals: boolean = selectedPropertyType.includes('Port Terminals');
        const flagTerminalsTransload: boolean = selectedPropertyType.includes('Terminals and Transload Facilities');
        const flagWarehouse: boolean = selectedPropertyType.includes('Warehouse/Distribution Center');
        const flagMultipurpose: boolean = selectedPropertyType.includes('Multipurpose');
        if (flagIndustrialSitesProperties) {
            this.setListingFor(selectedPropertyType);
        }
        if (flagWarehouse) {
            // this.addColdStorageInCapabilities();
            this.setListingFor(selectedPropertyType);
        }
        if (flagMultipurpose) {
            this.setListingFor(selectedPropertyType);
            // this.addColdStorageInCapabilities();
        }
        if (!flagWarehouse && !flagMultipurpose) {
            // this.removePTTOptionFromListingFor();
        }
        const filter: LiFilter = new LiFilter().copy(this.state.filter);
        // const filter: LiFilter = new LiFilter()
        filter.selectedPropertyType = selectedPropertyType;
        console.log("selectedPropertyType", selectedPropertyType)
        this.setState({
            filter: filter
        }, () => {
            // this.createFilters();
            setStorageItem('selectedPropertyType', selectedPropertyType);
        });
        if (selectedPropertyType.length !== 0) {
            if (selectedPropertyType.includes("*")) {
                this.setState({
                    showfun: true
                })
            }
            else {
                this.setState({
                    showfun: false
                })
            }

        }
        else {
            this.setState({
                showfun: false
            })
        }
    }
    render() {
        return (
            <div style={{ fontSize: '1rem', fontWeight: 300, lineHeight: 1.5, color: ' #4a4a4a', overflowX: 'hidden' }} className='body-home'>
                {/* <div className='homepage-header'>
                    <HomePageHeader data={this.props} onRef={ref => (this.child = ref)} />
                </div> */}
                <div style={{ marginTop: 30 }} className="bottom-left">
                    {/* <div style={{paddingLeft:0}} className='col-md-8  col-sm-8  margin-bottom-10'>
                        <div className='text-uppercase font-weight-bold pull-left cursor-pointer hover' style={{ fontSize: 12, paddingBottom: 5 }}>I am looking for</div>
                        <InputMultiSelectComponent
                            name='selectedPropertyType'
                            value={this.state.filter.selectedPropertyType}
                            options={propertyTypesOptions}
                            onHandleMultiSelect={this.handleSelectPropertyType}
                            isMulti={true}
                        />
                    </div> */}
                    {/* <div style={{ paddingLeft: 0 }} className='col-md-8  col-sm-8  margin-bottom-10'>

                        <Select
                            mode="multiple"
                            style={{ width: '100%' }}
                            placeholder="Select One Or More Listing Type(s)"
                            // defaultValue={['Industrial Sites & Properties']}
                            onChange={this.handleChange}
                            optionLabelProp="label"
                        >
                            <Option value="Industrial Sites & Properties" label="Industrial Sites & Properties">
                                <div style={{ fontSize: 16 }} className="demo-option-label-item">
                                    <span role="img" aria-label="Industrial Sites & Properties">
                                        <img src={NavMap4} style={{ width: 60, height: 60, marginRight: "20px" }} alt='img' />
                                    </span>
                                    Industrial Sites & Properties
                                </div>
                            </Option>
                            <Option value="Port Terminals" label=" Port Terminals">
                                <div style={{ fontSize: 16 }} className="demo-option-label-item">
                                    <span role="img" aria-label=" Port Terminals">
                                        <img src={NavMap1} style={{ width: 60, height: 60, marginRight: "20px" }} alt='img' />
                                    </span>
                                    Port Terminals
                                </div>
                            </Option>
                            <Option value="Terminals and Transload Facilities" label="Terminals and Transload Facilities">
                                <div style={{ fontSize: 16 }} className="demo-option-label-item">
                                    <span role="img" aria-label="Terminals and Transload Facilities">
                                        <img src={NavMap2} style={{ width: 60, height: 60, marginRight: "20px" }} alt='img' />
                                    </span>
                                    Terminals and Transload Facilities
                                </div>
                            </Option>
                            <Option value="Warehouse/Distribution Center" label="Warehouse/Distribution Center">
                                <div style={{ fontSize: 16 }} className="demo-option-label-item">
                                    <span role="img" aria-label="Warehouse/Distribution Center">
                                        <img src={NavMap3} style={{ width: 60, height: 60, marginRight: "20px" }} alt='img' />
                                    </span>
                                    Warehouse/Distribution Center
                                </div>
                            </Option>
                        </Select>
                    </div> */}

                    <div style={{ paddingLeft: 0 }} className='make-width-300 make-width-500 col-md-12  col-sm-12  margin-bottom-10'>
                        <div className='text-uppercase font-weight-bold' style={{ fontSize: 12, paddingBottom: 5 }}>
                            {/* Select address */}
                            {
                                (!this.state.filter.cityCoordinates || this.state.filter.cityCoordinates.length < 2) ? null :
                                    <button type='button'
                                        className='close text-uppercase font-weight-bold'
                                        onClick={() => this.clearAddress()}
                                        style={Object.assign({
                                            fontSize: 12,
                                            width: 50,
                                            marginRight: 20,
                                        },
                                        )}
                                    >
                                        clear
                                    </button>
                            }
                        </div>

                        <InputAddressComponent hideAutoCompleteBorder
                            onHandleAddressChange={this.handleAddressChange}
                            value={this.state.filter.address}
                        />




                        <div style={{ marginBottom: 5 }}></div>
                    </div>
                    <div style={{ marginTop: 30, paddingLeft: 0 }} className='col-md-8  col-sm-8  margin-bottom-10'>
                        <Link id="slider-2-slide-2-layer-3"
                            className="rs-layer iq-button iq-btn-round rev-btn"
                            to={{
                                pathname: "/view-listings", state: {
                                    propertyType: 'Industrial Sites & Properties*Port Terminals*Terminals and Transload Facilities*Warehouse/Distribution Center'
                                }
                            }}
                            rel="nofollow"
                            data-type="button" data-rsp_ch="on"
                            data-xy="xo:130px,92px,69px,42px;yo:582px,430px,290px,247px;"
                            data-text="w:normal;s:18,12,20,16;l:18,12,24,16;" data-dim="h:50px,35px,50px,50px;minh:0px,none,none,none;"
                            data-padding="t:15,11,15,15;r:30,21,30,25;b:15,11,15,15;l:30,21,30,25;" data-border="bor:10px,10px,10px,10px;"
                            data-frame_0="x:-50,-35,-26,-16;" data-frame_1="st:1300;sp:1000;sR:1300;" data-frame_999="o:0;st:w;sR:6700;"
                            data-frame_hover="bgc:#007aff;bor:10px,10px,10px,10px;sp:100;e:Power1.easeInOut;bri:120%;"
                            style={{
                                zIndex: 1, backgroundColor: "#009df5", fontFamily: "Roboto , sans-serif", textTransform: "capitalize", visibility: 'visible', textAlign: 'left', lineHeight: '18px', letterSpacing: '0px', fontWeight: 200,
                                fontSize: '18px', borderColor: 'rgba(255, 255, 255, 0)', borderStyle: 'none', margin: '0px', borderRadius: '10px', padding: '15px 30px', color: 'rgb(255, 255, 255)', textDecoration: 'none', whiteSpace: 'nowrap', width: '150px', height: '50px', minHeight: '0px', minWidth: '0px', maxHeight: 'none', maxWidth: 'none', filter: 'blur(0px) grayscale(0%) brightness(100%)', opacity: 1, transformOrigin: '50% 50% 0px',
                                transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)', borderWidth: '0px'
                            }}>
                            <img src={search} style={{ width: 50, height: 35, margin: "-7px -5px 0px -35px" }} alt='img' />
                            <span style={{ marginBottom: 5,textTransform: 'uppercase',fontSize:15,fontWeight:600  }}>Go to Map</span>
                        </Link>

                        {/* <b style={{ marginLeft: 10, marginRight: -10, fontWeight: 700, color: 'rgb(20, 33, 73)' }}>OR</b>

                        <div id="slider-2-slide-2-layer-3" className="rs-layer iq-button iq-btn-round rev-btn"
                            data-type="button" data-rsp_ch="on"
                            data-xy="xo:130px,92px,69px,42px;yo:582px,430px,290px,247px;"
                            data-text="w:normal;s:18,12,20,16;l:18,12,24,16;" data-dim="h:50px,35px,50px,50px;minh:0px,none,none,none;"
                            data-padding="t:15,11,15,15;r:30,21,30,25;b:15,11,15,15;l:30,21,30,25;" data-border="bor:10px,10px,10px,10px;"
                            data-frame_0="x:-50,-35,-26,-16;" data-frame_1="st:1300;sp:1000;sR:1300;" data-frame_999="o:0;st:w;sR:6700;"
                            data-frame_hover="bgc:#007aff;bor:10px,10px,10px,10px;sp:100;e:Power1.easeInOut;bri:120%;"
                            style={{
                                zIndex: 1, backgroundColor: "#009df5", fontFamily: "Roboto , sans-serif", textTransform: "capitalize", visibility: 'visible', textAlign: 'left', lineHeight: '18px', letterSpacing: '0px', fontWeight: 200,
                                fontSize: '18px', borderColor: 'rgba(255, 255, 255, 0)', borderStyle: 'none', marginLeft: '35px', borderRadius: '10px', padding: '15px 30px', color: 'rgb(255, 255, 255)', textDecoration: 'none', whiteSpace: 'nowrap', width: 'auto', height: '50px', minHeight: '0px', minWidth: '0px', maxHeight: 'none', maxWidth: 'none', filter: 'blur(0px) grayscale(0%) brightness(100%)', opacity: 1, transformOrigin: '50% 50% 0px',
                                transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)', borderWidth: '0px'
                            }}>
                            {
                                this.state.showfun ?
                                    <a onClick={this.parentHandleShow} > <img src={createlist} style={{ width: 60, height: 40, margin: "-15px -5px 0px -20px" }} alt='img' /> <span style={{ marginBottom: 5, color: 'white' }}>List</span></a>
                                    :
                                    <Link to={{
                                        pathname: "/create-listings", state: {
                                            propertyType: this.state.filter.selectedPropertyType,
                                            address: this.state.filter.address,
                                        }
                                    }}> <img src={createlist} style={{ width: 60, height: 40, margin: "-15px -5px 0px -20px" }} alt='img' /> <span style={{ marginBottom: 5, color: 'white' }}>List</span></Link>
                            }


                        </div> */}

                    </div>

                </div>
                {
                    this.state.openSearch ?
                        // <>
                        //     <p id="slider-2-slide-2-layer-2" data-type="text"
                        //         data-color="#5e7290" data-rsp_ch="on" data-xy="xo:137px,97px,65px,40px;yo:448px,329px,185px,163px;"
                        //         data-text="w:normal;s:20,14,20,12;l:35,24,35,24;" data-frame_0="x:-50,-35,-26,-16;"
                        //         data-frame_1="st:1000;sp:1000;sR:1000;" data-frame_999="o:0;st:w;sR:7000;" className='title-text' style={{ zIndex: 10, marginLeft: 400
                        //             , marginTop: 20 ,fontFamily: "Roboto , sans-serif", fontSize: '20px', fontWeight: 300, textDecoration: 'none', width: 'auto', minHeight: '0px', minWidth: '0px', maxHeight: 'none', maxWidth: 'none', filter: 'blur(0px) grayscale(0%) brightness(100%)', opacity: 1, transformOrigin: '50% 50% 0px', color: '#4a4a4a' }}>
                        //             Apply Filters and See The Listings.
                        //     </p>
                        //     <div style={Object.assign({}, {
                        //         display: 'flex'
                        //         , marginLeft: 400
                        //         , marginTop: 0
                        //         , flexDirection: 'row'
                        //         , transition: 'width 1s ease-in-out'
                        //         , overflow: 'hidden'
                        //     }, {
                        //         width: '100%'
                        //         , height: 'auto'
                        //     }) as any}
                        //     >

                        //         {
                        //             this.renderIconFilters()
                        //         }

                        //         <div style={{ margin: 15 }} className="iq-btn-container">
                        //             <a className="iq-button iq-btn-round has-icon btn-icon-right d-inline" href="/view-listings"><span style={{ margin: 15, height: 50 }}>See Listings</span> </a>
                        //         </div>

                        //     </div>
                        // </>
                        <>
                            <div style={{ fontFamily: 'Roboto, sans-serif', fontSize: '1rem', fontWeight: 'normal', lineHeight: 1.2, color: ' #4a4a4a', overflowX: 'hidden' }} className='body-home'>

                                <div className='col-lg-12 col-md-12 padding-top-30'>
                                    <div className='row'>
                                        <form>
                                            <div className="col-lg-12">
                                                <div className="text-center iq-title-box iq-title-default iq-title-box-2 wow fadeInUp" data-wow-duration="0.6s">
                                                    {/* <span className="iq-subtitle">How It's Work</span> */}
                                                    <h2 style={{ textTransform: 'none', color: '#142149' }} className="iq-title">Industrial Site Search Made Easy</h2>
                                                    <p style={{ fontFamily: "Roboto , sans-serif", fontSize: '18px', margin: 20, fontWeight: 300, textDecoration: 'none', width: 'auto', minHeight: '0px', minWidth: '0px', maxHeight: 'none', maxWidth: 'none', filter: 'blur(0px) grayscale(0%) brightness(100%)', opacity: 1, transformOrigin: '50% 50% 0px', color: '#4a4a4a' }} className="iq-title">
                                                        Industrial Navigator simplifies the process of searching for and marketing all of the location-based assets needed for an industrial supply chain.
                                                        Industrial sites, ports, terminals, transload facilities, warehouses, and distribution centers are within reach with easy-to-use maps and filters. Search for, or list your property with us below!
                                                        <br />Select a one or more listing type(s) and/or address
                                                    </p>

                                                </div>
                                            </div>
                                            <div className='col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10'>
                                                {/* <Button onclick={this.addlistType("Industrial Sites & Properties")} id='contactusButon' style={{ borderRadius: '0px !important', background: '#4DAFFF', height: 50, width: '20%', fontSize: 18, paddingLeft: 25, paddingRight: 25,margin:10 }} >
                                                    <span className='pull-left '>See Listings</span>
                                                </Button> */}
                                                <div className='col-md-1  col-sm-1  margin-bottom-10'>
                                                    <img style={{ maxHeight: 100, maxWidth: 100 }} className="hover-img img-fluid" src={NavMap4} alt="fancybox" />
                                                    <h4 style={{ fontSize: '1.063em', color: '#142149' }} className="iq-step-title mt-3 mb-3">Industrial Sites</h4>
                                                </div>
                                                <div className='col-md-1  col-sm-1 col-sm-offset-2 margin-bottom-10'>
                                                    <img style={{ maxHeight: 100, maxWidth: 100 }} className="hover-img img-fluid" src={NavMap1} alt="fancybox" />
                                                    <h4 style={{ fontSize: '1.063em', color: '#142149' }} className="iq-step-title mt-3 mb-3">Ports</h4>
                                                </div>
                                                <div className='col-md-1  col-sm-1 col-sm-offset-2 margin-bottom-10'>
                                                    <img style={{ maxHeight: 100, maxWidth: 100 }} className="hover-img img-fluid" src={NavMap2} alt="fancybox" />
                                                    <h4 style={{ fontSize: '1.063em', color: '#142149' }} className="iq-step-title mt-3 mb-3">Terminals and Transloads</h4>
                                                </div>
                                                <div className='col-md-1  col-sm-1 col-sm-offset-2 margin-bottom-10'>
                                                    <img style={{ maxHeight: 100, maxWidth: 100 }} className="hover-img img-fluid" src={NavMap3} alt="fancybox" />
                                                    <h4 style={{ fontSize: '1.063em', color: '#142149' }} className="iq-step-title mt-3 mb-3">Warehouses</h4>
                                                </div>


                                            </div>
                                            <div className='col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10'>
                                                <div className='text-uppercase font-weight-bold pull-left cursor-pointer hover' style={{ fontSize: 12, paddingBottom: 5 }}>I am looking for</div>
                                                <InputMultiSelectComponent
                                                    name='selectedPropertyType'
                                                    value={this.state.filter.selectedPropertyType}
                                                    options={propertyTypesOptions}
                                                    onHandleMultiSelect={this.handleSelectPropertyType}
                                                    isMulti={true}
                                                />
                                            </div>
                                            <div className='col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10'>
                                                <div className='text-uppercase font-weight-bold' style={{ fontSize: 12, paddingBottom: 5 }}>
                                                    Select states
                                                </div>
                                                <InputMultiSelectComponent name='selectedUsaStates'
                                                    value={this.state.filter.selectedUsaStates}
                                                    options={arrStates}
                                                    onHandleMultiSelect={(name: string, valueArr: Array<LabelValue>) => {
                                                        this.resetAddress(() => {
                                                            const str = joinFilterV(valueArr);
                                                            const filter: LiFilter = new LiFilter().copy(this.state.filter);
                                                            filter.selectedUsaStates = str;
                                                            this.setState({
                                                                filter: filter
                                                            }, () => {
                                                                // this.createFilters();
                                                                setStorageItem(name, str);
                                                            });
                                                        });
                                                    }}
                                                    isMulti={true}
                                                />
                                            </div>
                                            <div className='col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10 text-center font-weight-bold'>OR</div>
                                            <div className='col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10'>
                                                <div className='text-uppercase font-weight-bold' style={{ fontSize: 12, paddingBottom: 5 }}>
                                                    Select address
                                                    {
                                                        (!this.state.filter.cityCoordinates || this.state.filter.cityCoordinates.length < 2) ? null :
                                                            <button type='button'
                                                                className='close text-uppercase font-weight-bold'
                                                                onClick={() => this.clearAddress()}
                                                                style={Object.assign({
                                                                    fontSize: 12,
                                                                    width: 50,
                                                                    marginRight: 20,
                                                                },
                                                                )}
                                                            >
                                                                clear
                                                            </button>
                                                    }
                                                </div>

                                                <InputAddressComponent hideAutoCompleteBorder
                                                    onHandleAddressChange={this.handleAddressChange}
                                                    value={this.state.filter.address}
                                                />




                                                <div style={{ marginBottom: 5 }}></div>
                                            </div>
                                            {/* <div className="col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10">
                                                <a className="iq-button iq-btn-round has-icon btn-icon-right d-inline " href="/view-listings"><span style={{ margin: 15, height: 50 }}>See Listings</span> </a>
                                            </div> */}

                                            <div className='col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 margin-bottom-10 text-center'>
                                                <Link style={{ margin: 30 }} to={{ pathname: '/view-listings' }} >
                                                    <Button id='contactusButon' style={{ borderRadius: '0px !important', background: '#4DAFFF', height: 50, width: '20%', fontSize: 18, paddingLeft: 25, paddingRight: 25 }} >
                                                        <span className='pull-left '>See Listings</span>
                                                    </Button>
                                                </Link>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        null
                }





                <Modal show={this.state.showSuccessModal} onHide={this.handleSuccessModal} style={{ padding: '0px!important', opacity: 1 }} animation={false}>
                    <Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
                    <Modal.Body style={{ background: 'white', padding: '1rem', marginBottom: '0px' }}>
                        <div className='text-center' style={{ paddingTop: '1rem', paddingLeft: '3rem', paddingRight: '3rem' }}>
                            <div className='event-type info'>
                                <div className='event-indicator '>
                                    <SVGIcon />
                                </div>
                            </div>
                            <h2 className='text-black font-size-30 margin-bottom-10' style={{ textTransform: 'none' }}>
                                Contact Request Sent
                            </h2>
                            <p className='text-muted font-size-16-imp margin-bottom-0'>
                                Your request has been sent. We will get in touch with you!
                            </p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ display: 'block', padding: '10px', borderTop: '1px solid #e9ecef' }}>
                        <button type='button' className='btn btn-default border-radius-25-imp' onClick={this.handleSuccessModal}>Close</button>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}

export default HomePage;

const SVGIcon = () => (
    <svg style={{ width: 60, height: 60 }} viewBox='0 0 24 24'>
        <path fill='#fff' d='M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' />
    </svg>
)

const CreateSVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='23'
        height='24'
        viewBox='0 0 23 24'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#4DAFFF' transform='translate(-871 -1441)'>
                <g transform='translate(-27)'>
                    <g transform='translate(157 780)'>
                        <g transform='translate(700 480)'>
                            <g transform='translate(40 181)'>
                                <g transform='translate(1)'>
                                    <path
                                        d='M21.556 21.41h-6.17v-1.493h5.68l-.9-2.739H15.88c-1.286 1.228-2.475 2.356-3.54 3.817l-1.137 1.557-1.136-1.557c-1.075-1.474-2.29-2.622-3.54-3.817H2.24l-.9 2.739h5.68v1.494H.85L0 24h22.407l-.85-2.59z'
                                        opacity='0.5'
                                    ></path>
                                    <path d='M11.203 20.166c3.39-4.647 8.216-6.44 8.216-11.95C19.42 3.508 15.911 0 11.203 0 6.497 0 2.988 3.508 2.988 8.216c0 5.51 4.827 7.305 8.215 11.95zm0-13.882a2.245 2.245 0 012.241 2.24 2.245 2.245 0 01-2.24 2.241 2.245 2.245 0 01-2.241-2.24 2.245 2.245 0 012.24-2.241z'></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

const BrowseSVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#4DAFFF' transform='translate(-998 -1441)'>
                <g transform='translate(-27)'>
                    <g transform='translate(157 780)'>
                        <g transform='translate(700 480)'>
                            <g transform='translate(168 181)'>
                                <path
                                    d='M10.845 11.105V6.072h1.213V4.716a5.303 5.303 0 00-2.898-.858 5.343 5.343 0 00-5.288 4.63h3.53v2.416h1.214V14.5a5.344 5.344 0 005.525-3.395h-3.296z'
                                    opacity='0.5'
                                ></path>
                                <path d='M16.823 14.206a9.106 9.106 0 001.497-5.013c0-5.051-4.109-9.16-9.16-9.16C4.11.033 0 4.142 0 9.193c0 5.05 4.11 9.16 9.16 9.16a9.11 9.11 0 005.276-1.676l7.135 7.103L24 21.35l-7.177-7.144zM9.16 15.937a6.752 6.752 0 01-6.744-6.744A6.752 6.752 0 019.16 2.449a6.752 6.752 0 016.745 6.744 6.752 6.752 0 01-6.745 6.744z'></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

const FindSVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='80'
        height='80'
        viewBox='0 0 80 80'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#4DAFFF' transform='translate(-230 -1660)'>
                <g transform='translate(-27)'>
                    <g transform='translate(177 1660)'>
                        <g transform='translate(80)'>
                            <path
                                d='M53 64v14H36V64h17zm-23-8v22H20V56h10zm48-15v14H61V41h17zM25 2c9.89 0 18.321 6.242 21.57 15H47l.001 1.274C47.651 20.402 48 22.66 48 25c0 12.703-10.297 23-23 23S2 37.703 2 25 12.297 2 25 2zm-.5 5C14.835 7 7 14.835 7 24.5S14.835 42 24.5 42c7.368 0 13.673-4.553 16.253-11H30V17h10.316C37.507 11.088 31.481 7 24.5 7z'
                                opacity='0.2'
                            ></path>
                            <path d='M24.516 0C34.442 0 43.36 6.021 47.14 15.104l.154.38H77.42a2.584 2.584 0 012.576 2.418l.005.163v12.903a2.584 2.584 0 01-2.418 2.575l-.163.005H47.284a24.387 24.387 0 01-2.42 4.624l-.372.538h32.927a2.584 2.584 0 012.576 2.417l.005.163v12.904a2.584 2.584 0 01-2.418 2.575l-.163.005H41.29a2.584 2.584 0 01-2.575-2.417l-.005-.163v-9.709a24.434 24.434 0 01-8.095 3.759c.195.57.315 1.164.345 1.773l.008.306v25.806a3.876 3.876 0 01-3.672 3.866l-.2.005h-5.16a3.876 3.876 0 01-3.866-3.672l-.005-.199V50.323c0-.72.127-1.422.356-2.09C7.848 45.514 0 35.927 0 24.517 0 10.997 10.997 0 24.516 0zm47.742 61.935a2.584 2.584 0 012.576 2.418l.005.163V77.42a2.584 2.584 0 01-2.418 2.576l-.163.005H36.13a2.584 2.584 0 01-2.576-2.418l-.005-.163V64.516a2.584 2.584 0 012.418-2.575l.163-.006h36.13zm-43.87-5.16h-7.743v19.354c0 .667.51 1.217 1.159 1.284l.131.006h5.162c.666 0 1.217-.509 1.283-1.158l.007-.132V56.774zm23.225 7.741H36.129V77.42h15.484V64.516zm20.645 0H54.194V77.42h18.065V64.516zM48.12 66.185l1.825 1.824-8.655 8.654-3.493-3.493 1.825-1.824 1.668 1.668 6.83-6.83zm11.235 3.492v2.581h-2.58v-2.58h2.58zm5.161 0v2.581h-2.58v-2.58h2.58zm5.161 0v2.581h-2.58v-2.58h2.58zM77.42 41.29H61.935v12.904H77.42V41.29zm-18.064 0H41.29v12.904h18.065V41.29zm-38.368 7.458a3.898 3.898 0 00-.334 1.34l-.008.235v3.87h7.742v-3.87c0-.549-.121-1.08-.34-1.57a24.53 24.53 0 01-3.53.28c-1.202 0-2.374-.117-3.53-.285zm51.65-5.79l1.824 1.825-2.96 2.959 2.96 2.959-1.825 1.824-2.959-2.959-2.958 2.96-1.825-1.825 2.959-2.96-2.959-2.958 1.825-1.824 2.958 2.958 2.96-2.958zm-26.185 3.494v2.58H43.87v-2.58h2.58zm5.16 0v2.58h-2.58v-2.58h2.58zm5.162 0v2.58h-2.58v-2.58h2.58zM24.516 2.58c-12.095 0-21.935 9.84-21.935 21.935 0 12.096 9.84 21.936 21.935 21.936A21.887 21.887 0 0038.72 41.21a2.574 2.574 0 012.49-2.493 21.867 21.867 0 003.054-4.663l.236-.506h-2.874c-3.333 6.293-9.953 10.323-17.109 10.323-10.672 0-19.355-8.683-19.355-19.355S13.844 5.161 24.516 5.161c7.028 0 13.539 3.887 16.927 9.988l.182.335h2.882C40.987 7.697 33.175 2.58 24.517 2.58zm0 5.16c-9.249 0-16.774 7.526-16.774 16.775 0 9.25 7.525 16.774 16.774 16.774 5.608 0 10.838-2.855 13.924-7.434l.203-.308h-7.675a2.584 2.584 0 01-2.576-2.417l-.005-.163V18.065a2.584 2.584 0 012.418-2.576l.163-.005h7.675c-3.057-4.759-8.394-7.742-14.127-7.742zm21.936 10.324H30.968v12.903h15.484V18.065zm30.967 0H49.032v12.903h28.389l-.002-12.903zm-34.46 1.668l1.824 1.824-8.654 8.655-3.493-3.493 1.825-1.825 1.668 1.669 6.83-6.83zm31.88 3.493v2.58h-2.58v-2.58h2.58zm-5.162 0v2.58h-2.58v-2.58h2.58zm-5.16 0v2.58h-2.582v-2.58h2.581zm-5.162 0v2.58h-2.58v-2.58h2.58zm-5.161 0v2.58h-2.581v-2.58h2.58z'></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

const SearchFlexibilitySVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='80'
        height='80'
        viewBox='0 0 80 80'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#4DAFFF' transform='translate(-530 -1660)'>
                <g transform='translate(-27)'>
                    <g transform='translate(177 1660)'>
                        <g transform='translate(300)'>
                            <g transform='translate(80)'>
                                <path
                                    d='M79 71v8h-8v-8h8zM63 46v33H47a4 4 0 01-4-4V63H31v-7h12v-1h13v-9h7zM23 56v7h2v13a3 3 0 01-3 3H10v-8H5a4 4 0 01-4-4V56h22zm56-10v17h-8V46h8zM11.369 20l10.566 20.29h2.581L35.082 20H37v27H2V20h9.369zM55 20v27h-9V20h9zm7 11v6h-6v-6h6zm17 0v6h-8v-6h8z'
                                    opacity='0.2'
                                ></path>
                                <path d='M23.226 0c7.826 0 14.193 6.368 14.193 14.194v.665c0 1.08-.136 2.155-.38 3.206h14.574a5.166 5.166 0 015.161 5.16v5.162h12.903v-2.71c-2.94-.6-5.16-3.207-5.16-6.322a6.459 6.459 0 016.45-6.452 6.459 6.459 0 016.452 6.452c0 3.116-2.22 5.721-5.16 6.321v2.711H80V80H46.452a5.166 5.166 0 01-5.162-5.161V64.516H27.097V74.84A5.166 5.166 0 0121.935 80H9.032v-7.742h-3.87A5.166 5.166 0 010 67.097V23.226a5.166 5.166 0 015.161-5.161h4.252a14.182 14.182 0 01-.38-3.206v-.665C9.032 6.368 15.4 0 23.225 0zm46.451 30.968h-5.16v7.742h-7.743v5.161h7.742v33.548h5.161v-7.742h7.742v-5.16h-7.742V43.87h7.742V38.71h-5.16v2.58h-2.582V30.968zm-47.742 41.29H11.613v5.161h10.322a2.583 2.583 0 002.581-2.58 2.583 2.583 0 00-2.58-2.58zm40-25.806h-5.16v20.645a5.166 5.166 0 01-5.162 5.161h-5.161a2.583 2.583 0 00-2.581 2.58 2.583 2.583 0 002.58 2.581h15.484V46.452zM77.42 72.258h-5.16v5.161h5.16v-5.16zm-52.903-7.742H5.161a2.583 2.583 0 00-2.58 2.58 2.583 2.583 0 002.58 2.581h16.774c.945 0 1.819.274 2.581.718v-5.879zm27.097 0H43.87v5.879a5.108 5.108 0 012.58-.718h5.162a2.583 2.583 0 002.58-2.58 2.583 2.583 0 00-2.58-2.58zm-29.678-7.742H2.581v5.879a5.108 5.108 0 012.58-.718h16.774v-5.16zm32.259 0H32.258v5.161h19.355c.944 0 1.818.274 2.58.718v-5.879zm23.225-10.322h-5.16v15.483h5.16V46.452zM43.871 20.645H38.71v28.387H2.58v5.162h21.936v7.741h5.161v-7.741h24.517v-5.162H43.87V20.645zm7.742 0h-5.161v25.807h7.742V23.226a2.583 2.583 0 00-2.581-2.58zm-41.319 0H5.161a2.583 2.583 0 00-2.58 2.58v23.227h33.548V20.708c-.119.265-.223.536-.359.793l-9.51 17.962a3.423 3.423 0 01-3.034 1.827c-1.276 0-2.439-.699-3.035-1.828L10.681 21.5c-.146-.278-.26-.57-.387-.856zM7.742 41.29v2.581h-2.58v-2.58h2.58zm5.161 0v2.581h-2.58v-2.58h2.58zm5.162 0v2.581h-2.581v-2.58h2.58zm-2.581-5.161v2.58H5.16v-2.58h10.323zm7.742-33.548c-6.403 0-11.613 5.21-11.613 11.613v.665c0 1.888.467 3.767 1.35 5.434l9.51 17.962c.295.56 1.21.56 1.505 0l9.511-17.962a11.663 11.663 0 001.35-5.434v-.665c0-6.403-5.21-11.613-11.613-11.613zm54.193 28.387h-5.16v5.161h5.16v-5.161zm-15.484 0h-5.16v5.161h5.16v-5.161zm-46.451 0v2.58H5.16v-2.58h10.323zm11.613-5.162v2.581h-2.58v-2.58h2.58zm-5.162 0v2.581h-2.58v-2.58h2.58zm1.29-20.645c4.981 0 9.033 4.052 9.033 9.033 0 4.98-4.052 9.032-9.032 9.032s-9.032-4.052-9.032-9.032c0-4.981 4.051-9.033 9.032-9.033zm47.743 10.323a3.876 3.876 0 00-3.871 3.87 3.876 3.876 0 003.87 3.872 3.876 3.876 0 003.872-3.871 3.876 3.876 0 00-3.871-3.871zM23.226 7.742a6.459 6.459 0 00-6.452 6.452 6.459 6.459 0 006.452 6.451 6.459 6.459 0 006.451-6.451 6.459 6.459 0 00-6.451-6.452z'></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

const MoreFromSearchSVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='80'
        height='80'
        viewBox='0 0 80 80'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#4DAFFF' transform='translate(-830 -1660)'>
                <g transform='translate(-27)'>
                    <g transform='translate(177 1660)'>
                        <g transform='translate(600)'>
                            <g transform='translate(80)'>
                                <path
                                    d='M44 66v9a4 4 0 11-8 0v-9h8zM12.874 14.119c3.093 0 3.782 2.01 3.782 2.755 0 .745-1.81 2.35-3.782 2.35s-3.821 1.614-3.821 4.002c0 1.592 1.004 2.936 3.013 4.032h5.729l1.595 3.71L22 32.414h3.172l-.213.694C28.178 28.224 33.713 25 40 25c8.425 0 15.498 5.788 17.46 13.604-.047-.36-.094-.728-.145-1.104h8.592c2.478-.054 3.717.78 3.717 2.5s-1.24 2.58-3.717 2.58c-1.625.557-2.438 1.417-2.438 2.581 0 1.747.93 3.339 2.438 3.339 1.507 0 2.48.54 2.48 2.02v4.964H53l.143-.185A17.95 17.95 0 0140 61c-9.941 0-18-8.059-18-18l.001-.217-.066.217h-4.14l-6.51 5.5H5.76c-3.015-5.667-4.523-11.029-4.523-16.086 0-5.058 1.093-11.156 3.278-18.295zM40 30c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm17.962 14.179l-.01.135a17.892 17.892 0 01-1.707 6.447c1.17-2.03 1.755-3.68 1.755-4.955 0-.508-.013-1.05-.038-1.627zm6.18-42.889V9.91l-1.788 1.827H53l-1.387 2.383 1.387 2.8h12.458l1.956 2.757-1.956 2.3h-6.103L58 24.517l-.685 2.97L53 30l-5.258-4.194L40 24.516c0-4.128-1.29-6.193-3.871-6.193-3.87 0-5.161-1.822-5.161-4.204 0-2.383-1.194-2.383-2.58-2.383-1.388 0-6.453-.393-6.453-2.937 0-1.696-1.348-2.545-4.046-2.545H9.875l3.973-4.964H64.14z'
                                    opacity='0.2'
                                ></path>
                                <path d='M66.813 0l.372.345C75.329 7.895 80 18.587 80 29.677c0 9.855-3.62 19.326-10.194 26.668l-.384.43H53.145a19.322 19.322 0 01-9.275 4.772l.001 3.315a2.582 2.582 0 011.29 2.235v7.742A5.166 5.166 0 0140 80a5.166 5.166 0 01-5.161-5.161v-7.742c0-.954.52-1.788 1.29-2.235v-3.315a19.322 19.322 0 01-9.274-4.772H10.578l-.384-.43A39.929 39.929 0 010 29.677C0 18.587 4.671 7.895 12.817.345l.37-.345h53.626zM42.58 67.097h-5.162v7.742A2.583 2.583 0 0040 77.419a2.583 2.583 0 002.58-2.58v-7.742zM40 61.935c-.434 0-.864-.014-1.29-.042l-.001 2.623h2.581v-2.623c-.426.028-.856.042-1.29.042zm0-36.129c-9.249 0-16.774 7.526-16.774 16.775 0 9.249 7.525 16.774 16.774 16.774S56.774 51.83 56.774 42.58c0-9.25-7.525-16.775-16.774-16.775zm0 2.581c7.826 0 14.194 6.368 14.194 14.194 0 7.825-6.368 14.193-14.194 14.193-7.826 0-14.194-6.368-14.194-14.193 0-7.826 6.368-14.194 14.194-14.194zM67.097 38.71h-8.131a19.37 19.37 0 01.389 3.87c0 4.354-1.445 8.377-3.88 11.614l11.621-.001v-3.87c0-.711-.579-1.29-1.29-1.29a3.876 3.876 0 01-3.87-3.872 3.876 3.876 0 013.87-3.87h1.29c.712 0 1.291-.58 1.291-1.291s-.58-1.29-1.29-1.29zm-46.41 5.16l-1.028.001a3.36 3.36 0 00-3.02 1.867 5.928 5.928 0 01-5.33 3.294l-3.332.001a37.463 37.463 0 003.761 5.16l12.788.001a19.25 19.25 0 01-3.838-10.323zM40 30.969c-6.403 0-11.613 5.21-11.613 11.613 0 6.402 5.21 11.613 11.613 11.613s11.613-5.21 11.613-11.613S46.403 30.968 40 30.968zM65.806 2.59v6.442a3.876 3.876 0 01-3.87 3.871h-7.742c-.711 0-1.29.58-1.29 1.29 0 .712.579 1.29 1.29 1.29h10.322a3.876 3.876 0 013.871 3.872 3.876 3.876 0 01-3.87 3.87h-3.872c-.71 0-1.29.58-1.29 1.291a6.463 6.463 0 01-4.196 6.045 19.31 19.31 0 013.09 5.568h8.848A3.876 3.876 0 0170.967 40a3.876 3.876 0 01-3.87 3.871h-1.29c-.712 0-1.29.58-1.29 1.29 0 .711.578 1.29 1.29 1.29a3.876 3.876 0 013.87 3.872v2.138a37.341 37.341 0 007.742-22.784c0-10.203-4.225-20.045-11.613-27.087zM14.194 15.484H5.392a37.374 37.374 0 00-2.811 14.193 37.354 37.354 0 003.97 16.775h4.757a3.36 3.36 0 003.021-1.867 5.926 5.926 0 015.33-3.295h1.029c.184-2.78.957-5.402 2.197-7.742h-.95a3.876 3.876 0 01-3.87-3.87c0-.712-.58-1.29-1.29-1.29h-3.872a5.166 5.166 0 01-5.161-5.162 5.166 5.166 0 015.161-5.161h1.29c.712 0 1.29-.58 1.29-1.29 0-.712-.578-1.291-1.29-1.291zM49.032 41.29v2.581h-2.58v-2.58h2.58zm-5.161 0v2.581h-2.58v-2.58h2.58zm-5.161 0v2.581h-2.581v-2.58h2.58zm-5.162 0v2.581h-2.58v-2.58h2.58zM19.355 7.742H9.699a37.601 37.601 0 00-3.131 5.161h7.626a3.876 3.876 0 013.87 3.871 3.876 3.876 0 01-3.87 3.871h-1.29a2.583 2.583 0 00-2.581 2.58 2.583 2.583 0 002.58 2.581h3.871a3.876 3.876 0 013.871 3.871c0 .711.58 1.29 1.29 1.29h2.59c3.293-4.375 8.395-7.316 14.185-7.699v-.042a3.876 3.876 0 00-3.871-3.871h-1.29a3.876 3.876 0 01-3.872-3.871v-1.29c0-.711-.579-1.29-1.29-1.29h-3.87a3.876 3.876 0 01-3.872-3.872c0-.71-.58-1.29-1.29-1.29zm43.87-5.162H14.204a37.213 37.213 0 00-2.461 2.581h7.612a3.876 3.876 0 013.87 3.871c0 .711.58 1.29 1.291 1.29h3.871a3.876 3.876 0 013.871 3.872v1.29c0 .71.58 1.29 1.29 1.29h1.29a6.459 6.459 0 016.452 6.452v.042a19.286 19.286 0 0111.847 5.111 3.875 3.875 0 003.632-3.664l.005-.199a3.876 3.876 0 013.871-3.87h3.871c.711 0 1.29-.58 1.29-1.291s-.579-1.29-1.29-1.29H54.194a3.876 3.876 0 01-3.871-3.871 3.876 3.876 0 013.87-3.871h7.742c.711 0 1.29-.58 1.29-1.29V2.58z'></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

const DecisionSVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='80'
        height='80'
        viewBox='0 0 80 80'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#4DAFFF' transform='translate(-1130 -1660)'>
                <g transform='translate(-27)'>
                    <g transform='translate(177 1660)'>
                        <g transform='translate(900)'>
                            <g transform='translate(80)'>
                                <path d='M59.355 0v5.161h15.484A5.166 5.166 0 0180 10.323a5.166 5.166 0 01-5.161 5.16H59.355V29.98c1.508.542 2.63 1.132 3.404 1.618l1.537-3.074 1.252 1.67c2.566 3.421 3.538 6.346 3.906 8.091l4.094-1.365v1.79c0 6.072-1.104 9.92-1.32 10.615a5.145 5.145 0 01-4.291 4.783 8.99 8.99 0 01-3.572 4.747l-1.14.76v2.64l12.112 3.493A6.482 6.482 0 0180 71.947V80H36.129v-5.161H0v-63.76L11.079 0h48.276zm3.177 64.74l-4.467 7.444-4.467-7.444-12.09 3.488a3.89 3.89 0 00-2.798 3.719v5.472h6.684l1.083-5.415 2.53.507-.98 4.908h20.076l-.98-4.907 2.53-.507 1.082 5.414h6.684v-5.472a3.893 3.893 0 00-2.797-3.72l-12.09-3.488zM56.774 2.58h-43.87v10.323H2.58v59.355h33.548v-.311c0-.792.16-1.556.432-2.27h-31.4V56.774h41.29v7.342l6.452-1.86v-2.64l-1.139-.76a9 9 0 01-3.572-4.748 5.142 5.142 0 01-4.277-4.641c-.612-1.037-2.625-4.895-2.625-10.757v-1.79l3.246 1.082a25.094 25.094 0 01-.665-5.744v-1.653l4.484 1.121-1.113-3.339h1.79c3.113 0 5.667.345 7.742.835V15.484H39.696l-10.323-5.161L39.696 5.16h17.078v-2.58zm3.871 58.705a5.529 5.529 0 01-2.58.65 5.529 5.529 0 01-2.581-.65v1.584l2.58 4.301 2.581-4.301zm-16.774-1.93H7.741v7.742h30.622a6.372 6.372 0 012.429-1.349l3.079-.887v-5.506zm-2.58 2.58v2.581H15.483v-2.58H41.29zm-28.388 0v2.581h-2.58v-2.58h2.58zm51.062-18.064c-.285 0-.57.065-.826.195l-5.074 2.538-5.078-2.54a1.843 1.843 0 00-2.664 1.648v5.629a6.442 6.442 0 002.872 5.368l3.22 2.146c.981.654 2.315.654 3.297 0l3.22-2.146a6.442 6.442 0 002.874-5.368v-5.63a1.843 1.843 0 00-1.84-1.84zm-34.288 2.58a3.876 3.876 0 013.871 3.872 3.876 3.876 0 01-3.87 3.87 3.876 3.876 0 01-3.872-3.87 3.876 3.876 0 013.871-3.871zm-10.322 0a3.876 3.876 0 013.87 3.872 3.876 3.876 0 01-3.87 3.87 3.876 3.876 0 01-3.871-3.87 3.876 3.876 0 013.87-3.871zm-10.323 0a3.876 3.876 0 013.871 3.872 3.876 3.876 0 01-3.87 3.87 3.876 3.876 0 01-3.872-3.87 3.876 3.876 0 013.871-3.871zm10.323 2.581c-.71 0-1.29.579-1.29 1.29 0 .713.58 1.29 1.29 1.29.71 0 1.29-.577 1.29-1.29 0-.711-.58-1.29-1.29-1.29zm-10.323 0c-.71 0-1.29.579-1.29 1.29 0 .713.58 1.29 1.29 1.29.71 0 1.29-.577 1.29-1.29 0-.711-.58-1.29-1.29-1.29zm20.645 0c-.71 0-1.29.579-1.29 1.29 0 .713.58 1.29 1.29 1.29.711 0 1.29-.577 1.29-1.29 0-.711-.579-1.29-1.29-1.29zm18.065-2.222a2.573 2.573 0 00-1.29 2.222c0 .951.522 1.774 1.29 2.222zm20.645 0v4.444a2.573 2.573 0 001.29-2.222c0-.95-.522-1.774-1.29-2.222zm-17.55-15.798l1.452 4.36-5.777-1.446c.138 1.86.505 3.692 1.097 5.467l.883 2.647-4.549-1.516a20.187 20.187 0 001.12 5.25 5.135 5.135 0 013.041-1.809 4.426 4.426 0 014.06-2.675c.681 0 1.364.162 1.975.466l3.926 1.962 3.922-1.962a4.476 4.476 0 011.978-.466 4.429 4.429 0 014.06 2.675 5.12 5.12 0 012.463 1.208c.196-1.257.373-2.82.445-4.66l-3.836 1.278V39.98c-.012-.26-.181-2.863-2.408-6.472l-1.11 2.22-1.265-1.265c-.028-.026-3.263-3.053-11.478-3.45zM9.031 36.129A3.876 3.876 0 0112.903 40a3.876 3.876 0 01-3.87 3.871A3.876 3.876 0 015.16 40a3.876 3.876 0 013.871-3.871zm10.323 0A3.876 3.876 0 0123.225 40a3.876 3.876 0 01-3.87 3.871A3.876 3.876 0 0115.484 40a3.876 3.876 0 013.87-3.871zm10.322 0A3.876 3.876 0 0133.548 40a3.876 3.876 0 01-3.87 3.871A3.876 3.876 0 0125.805 40a3.876 3.876 0 013.871-3.871zm0 2.58c-.71 0-1.29.58-1.29 1.291 0 .71.58 1.29 1.29 1.29.711 0 1.29-.58 1.29-1.29 0-.71-.579-1.29-1.29-1.29zm-10.322 0c-.71 0-1.29.58-1.29 1.291 0 .71.58 1.29 1.29 1.29.71 0 1.29-.58 1.29-1.29 0-.71-.58-1.29-1.29-1.29zm-10.323 0c-.71 0-1.29.58-1.29 1.291 0 .71.58 1.29 1.29 1.29.71 0 1.29-.58 1.29-1.29 0-.71-.58-1.29-1.29-1.29zm20.645-12.903a3.876 3.876 0 013.871 3.871 3.876 3.876 0 01-3.87 3.871 3.876 3.876 0 01-3.872-3.87 3.876 3.876 0 013.871-3.872zm-20.645 0a3.876 3.876 0 013.871 3.871 3.876 3.876 0 01-3.87 3.871 3.876 3.876 0 01-3.872-3.87 3.876 3.876 0 013.871-3.872zm10.323 0a3.876 3.876 0 013.87 3.871 3.876 3.876 0 01-3.87 3.871 3.876 3.876 0 01-3.871-3.87 3.876 3.876 0 013.87-3.872zM9.032 28.387c-.71 0-1.29.58-1.29 1.29 0 .711.58 1.29 1.29 1.29.71 0 1.29-.579 1.29-1.29 0-.71-.58-1.29-1.29-1.29zm10.323 0c-.71 0-1.29.58-1.29 1.29 0 .711.58 1.29 1.29 1.29.71 0 1.29-.579 1.29-1.29 0-.71-.58-1.29-1.29-1.29zm10.322 0c-.71 0-1.29.58-1.29 1.29 0 .711.58 1.29 1.29 1.29.711 0 1.29-.579 1.29-1.29 0-.71-.579-1.29-1.29-1.29zM9.032 15.484a3.876 3.876 0 013.871 3.87 3.876 3.876 0 01-3.87 3.872 3.876 3.876 0 01-3.872-3.871 3.876 3.876 0 013.871-3.871zm10.323 0a3.876 3.876 0 013.87 3.87 3.876 3.876 0 01-3.87 3.872 3.876 3.876 0 01-3.871-3.871 3.876 3.876 0 013.87-3.871zm10.322 0a3.876 3.876 0 013.871 3.87 3.876 3.876 0 01-3.87 3.872 3.876 3.876 0 01-3.872-3.871 3.876 3.876 0 013.871-3.871zm-20.645 2.58c-.71 0-1.29.58-1.29 1.29 0 .712.58 1.291 1.29 1.291.71 0 1.29-.58 1.29-1.29 0-.71-.58-1.29-1.29-1.29zm10.323 0c-.71 0-1.29.58-1.29 1.29 0 .712.58 1.291 1.29 1.291.71 0 1.29-.58 1.29-1.29 0-.71-.58-1.29-1.29-1.29zm10.322 0c-.71 0-1.29.58-1.29 1.29 0 .712.58 1.291 1.29 1.291.711 0 1.29-.58 1.29-1.29 0-.71-.579-1.29-1.29-1.29zM61.935 7.743H41.29v5.161h20.645V7.742zm5.162 0h-2.58v5.161h2.58V7.742zm7.742 0h-5.162v5.161h5.162a2.583 2.583 0 002.58-2.58 2.583 2.583 0 00-2.58-2.581zm-49.033 2.58v2.581H15.484v-2.58h10.322zM38.71 8.54l-3.567 1.783 3.567 1.783V8.54zM10.323 4.405l-5.918 5.918h5.918V4.405zm15.483.756v2.58H15.484v-2.58h10.322z'></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

const RightArrowSVGIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
    >
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
            <g fill='#FFF' transform='translate(-1166 -2563)'>
                <g transform='translate(-27)'>
                    <g transform='translate(0 2140)'>
                        <g transform='translate(857 120)'>
                            <g transform='translate(0 286)'>
                                <g transform='translate(336 17)'>
                                    <path d='M10.334.244L20 10l-9.666 9.756-1.167-1.179 7.671-7.744H0V9.167h16.839L9.167 1.422 10.334.244z'></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)